import { isFunction } from 'lodash';

/**
 * Created by amorozov on 03-Oct-17.
 */

const Messages = {
    dashboard: {
        activityErrorList: 'dashboard.activityErrorList',
        addDashlet: 'dashboard.addDashlet',
        addDashboard: 'dashboard.addDashboard',
        addNewFilter: 'dashboard.addNewFilter',
        browseDashboard: 'dashboard.browseDashboard',
        organizations: 'dashboard.organizations',
        filterOrganizations: 'dashboard.filterOrganizations',
        deleteDashboard: 'dashboard.deleteDashboard',
        deleteDashboardMsg: 'dashboard.deleteDashboardMsg',
        title: 'dashboard.title',
        addPresetTitle: 'dashboard.addPresetTitle',
        dashboardNameError: 'dashboard.dashboardNameError',
        dashboardLimitError: 'dashboard.dashboardLimitError',
        dashboardOptions: 'dashboard.dashboardOptions',
        dashboardPanelTitle: 'dashboard.dashboardPanelTitle',
        defaultDashboard: 'dashboard.defaultDashboard',
        description: 'dashboard.description',
        deleteDashlet: 'dashboard.deleteDashlet',
        deleteDashletMsg: 'dashboard.deleteDashletMsg',
        deletePreset: 'dashboard.deletePreset',
        documentsByDir: 'dashboard.documentsByDir',
        documentsInError: 'dashboard.documentsInError',
        editDashlet: 'dashboard.editDashlet',
        emptyUserListError: 'dashboard.emptyUserListError',
        keyError: 'dashboard.keyError',
        myDashboards: 'dashboard.myDashboards',
        name: 'dashboard.name',
        presetError: 'dashboard.presetError',
        query: 'dashboard.query',
        reloadFilter: 'dashboard.reloadFilter',
        selectKey: 'dashboard.selectKey',
        selectChartType: 'dashboard.selectChartType',
        sharedDashboard: 'dashboard.sharedDashboard',
        shareDashboard: 'dashboard.shareDashboard',
        shareForbiddenTitle: 'dashboard.shareForbiddenTitle',
        shareForbiddenContent: 'dashboard.shareForbiddenContent',
        shareForbiddenOkay: 'dashboard.shareForbiddenOkay',
        shareWithGroup: 'dashboard.shareWithGroup',
        shareWithIndividual: 'dashboard.shareWithIndividual',
        todayStageChart: 'dashboard.todayStageChart',
        kiloCharDashlet: 'dashboard.kiloCharDashlet',
        documentByAck: 'dashboard.documentByAck',
        tradingPartnerInbound: 'dashboard.tradingPartnerInbound',
        tradingPartnerOutbound: 'dashboard.tradingPartnerOutbound',
        weekStageChart: 'dashboard.weekStageChart',
        noDocuments: 'dashboard.noDocuments',
        timeIntervals: {
            customRange: 'dashboard.timeIntervals.customRange',
            lastMonth: 'dashboard.timeIntervals.lastMonth',
            lastWeek: 'dashboard.timeIntervals.lastWeek',
            lastYear: 'dashboard.timeIntervals.lastYear',
            today: 'dashboard.timeIntervals.today'
        },
        directionFilters: {
            both: 'dashboard.directionFilters.both',
            inbound: 'dashboard.directionFilters.inbound',
            outbound: 'dashboard.directionFilters.outbound'
        }
    },
    outboundForm: {
        fields: {
            selectTemplate: 'outboundForm.fields.selectTemplate',
            senderName: 'outboundForm.fields.senderName',
            receiverName: 'outboundForm.fields.receiverName',
            populateTemplate: 'outboundForm.fields.populateTemplate'
        },
        actionMessages: {
            draft: {
                title: 'outboundForm.actionMessages.draft.title',
                message: 'outboundForm.actionMessages.draft.message',
                information: 'outboundForm.actionMessages.draft.information'
            },
            publish: {
                title: 'outboundForm.actionMessages.publish.title',
                message: 'outboundForm.actionMessages.publish.message',
                information: 'outboundForm.actionMessages.publish.information'
            },
            next: {
                title: 'outboundForm.actionMessages.next.title',
                message: 'outboundForm.actionMessages.next.message',
                information: 'outboundForm.actionMessages.next.information'
            },
            revisit: {
                title: 'outboundForm.actionMessages.revisit.title',
                message: 'outboundForm.actionMessages.revisit.message',
                information: 'outboundForm.actionMessages.revisit.information'
            },
            delete: {
                title: 'outboundForm.actionMessages.delete.title',
                message: 'outboundForm.actionMessages.delete.message',
                information: 'outboundForm.actionMessages.delete.information'
            },
            resend: {
                title: 'outboundForm.actionMessages.resend.title',
                message: 'outboundForm.actionMessages.resend.message',
                information: 'outboundForm.actionMessages.resend.information'
            },
            reset: {
                title: 'outboundForm.actionMessages.reset.title',
                message: 'outboundForm.actionMessages.reset.message',
                information: 'outboundForm.actionMessages.reset.information'
            }
        },
        alertMessages: {
            draft: {
                title: 'outboundForm.alertMessages.draft.title',
                message: 'outboundForm.alertMessages.draft.message'
            },
            next: {
                title: 'outboundForm.alertMessages.next.title',
                message: 'outboundForm.alertMessages.next.message'
            },
            publish: {
                title: 'outboundForm.alertMessages.publish.title',
                message: 'outboundForm.alertMessages.publish.message'
            },
            delete: {
                title: 'outboundForm.alertMessages.delete.title',
                message: 'outboundForm.alertMessages.delete.message'
            },
            resend: {
                title: 'outboundForm.alertMessages.resend.title',
                message: 'outboundForm.alertMessages.resend.message'
            },
            reset: {
                title: 'outboundForm.alertMessages.reset.title',
                message: 'outboundForm.alertMessages.reset.message'
            }
        },
        errorMessages: {
            referenceMissing: () => {
                return {
                    key: 'outboundForm.errorMessages.referenceMissing',
                    paramsMap: ['referenceMissing']
                };
            },
            duplicateDraft: 'outboundForm.errorMessages.duplicateDraft'
        }
    },
    outboxDocument: {
        deleteTitle: 'outboxDocument.deleteTitle',
        deleteMessage: 'outboxDocument.deleteMessage',
        deleteInformation: 'outboxDocument.deleteInformation',
        deleteErrorMessage: 'outboxDocument.deleteErrorMessage',
        errorLogs: 'outboxDocument.errorLogs',
        errorMessageLabel: 'outboxDocument.errorMessageLabel',
        dateLabel: 'outboxDocument.dateLabel',
        outboxInfo: 'outboxDocument.outboxInfo',
        errorDetailsTitle: 'outboxDocument.errorDetailsTitle'
    },
    forms: {
        addMappings: 'forms.addMappings',
        csfMappings: 'forms.csfMappings',
        catalogueManagement: 'forms.catalogueManagement',
        addCatalogueManagement: 'forms.addCatalogueManagement',
        updateCatalogueManagement: 'forms.updateCatalogueManagement',
        addFromCatalogue: 'forms.addFromCatalogue',
        shipmentLabels: 'forms.shipmentLabels',
        createShipmentLabel: 'forms.createShipmentLabel',
        published: 'forms.published',
        createForm: 'forms.createForm',
        docCount: () => {
            return {
                key: 'forms.docCount',
                paramsMap: ['x', 'y']
            };
        },
        docWarning: () => {
            return {
                key: 'forms.docWarning',
                paramsMap: ['doc']
            };
        },
        deleteWarning: 'forms.deleteWarning',
        deleteWarningOutbox: 'forms.deleteWarningOutbox',
        deleteWarningDraft: 'forms.deleteWarningDraft',
        deleteForm: 'forms.deleteForm',
        drafts: 'forms.drafts',
        title: 'forms.title',
        formEmailMessage: 'forms.formEmailMessage',
        formExportEnglish: 'forms.formExportEnglish',
        formExportGerman: 'forms.formExportGerman',
        deleteDialog: {
            title: 'forms.deleteDialog.title',
            bulkDeleteAlert: () => {
                return {
                    key: 'forms.deleteDialog.bulkDeleteAlert',
                    paramsMap: ['eligible', 'total']
                };
            },
            continueMessage: 'forms.deleteDialog.continueMessage',
            ineligibleDocsTitle: 'forms.deleteDialog.ineligibleDocsTitle',
            criteria: 'forms.deleteDialog.criteria',
            successMessage: 'forms.deleteDialog.successMessage',
            errorMessage: 'forms.deleteDialog.errorMessage'
        },
        fields: {
            actions: 'forms.fields.actions',
            author: 'forms.fields.author',
            createdAt: 'forms.fields.createdAt',
            csfField: 'forms.fields.csfField',
            form: 'forms.fields.form',
            fileName: 'forms.fields.fileName',
            formField: 'forms.fields.formField',
            formMappingName: 'forms.fields.formMappingName',
            group: 'forms.fields.group',
            sourceField: 'forms.fields.sourceField',
            targetField: 'forms.fields.targetField',
            enumField: 'forms.fields.enumField',
            receiver: 'forms.fields.receiver',
            saved: 'forms.fields.saved',
            sender: 'forms.fields.sender',
            source: 'forms.fields.source',
            sourceField: 'forms.fields.sourceField',
            target: 'forms.fields.target',
            reference: 'forms.fields.reference',
            targetField: 'forms.fields.targetField',
            updatedAt: 'forms.fields.updatedAt',
            targetType: 'forms.fields.targetType',
            ID: 'forms.fields.ID',
            key: 'forms.fields.key',
            name: 'forms.fields.name',
            documentType: 'forms.fields.documentType',
            sourceType: 'forms.fields.sourceType',
            mappingType: 'forms.fields.mappingType',
            features: 'forms.fields.features',
            media: 'forms.fields.media',
            status: 'forms.fields.status',
            storageMappingName: 'forms.fields.storageMappingName',
            labelType: 'forms.fields.labelType',
            drafts: 'forms.fields.drafts',
            outbox: 'forms.fields.outbox',
            view: 'forms.fields.view',
            delete: 'forms.fields.delete',
            template: 'forms.fields.template',
            tradingPartner: 'forms.fields.tradingPartner',
            type: 'forms.fields.type',
            partnerGroup: 'forms.fields.partnerGroup',
            value: 'forms.fields.value',
            createdOn: 'forms.fields.createdOn',
            modifiedOn: 'forms.fields.modifiedOn',
            labelName: 'forms.fields.labelName',

            itemName: 'forms.fields.itemName',
            europeanArticleNumber: 'forms.fields.europeanArticleNumber',
            partnerName: 'forms.fields.partnerName',
            buyerPartNumber: 'forms.fields.buyerPartNumber',
            supplierPartNumber: 'forms.fields.supplierPartNumber',
            modelYear: 'forms.fields.modelYear',
            description: 'forms.fields.description',
            partNumberStatus: 'forms.fields.partNumberStatus',
            statusActive: 'forms.fields.statusActive',
            statusInactive: 'forms.fields.statusInactive',
            statusDraft: 'forms.fields.statusDraft',

            weight: 'forms.fields.weight',
            unitOfMeasure: 'forms.fields.unitOfMeasure',
            size: 'forms.fields.size',
            color: 'forms.fields.color',
            packageTemperature: 'forms.fields.packageTemperature',

            currencyType: 'forms.fields.currencyType',
            basePrice: 'forms.fields.basePrice',
            taxType: 'forms.fields.taxType',
            taxPercentage: 'forms.fields.taxPercentage',
            discountInDollar: 'forms.fields.discountInDollar',
            chargesInDollar: 'forms.fields.chargesInDollar',

            quantityPerPack: 'forms.fields.quantityPerPack',
            packContainerCode: 'forms.fields.packContainerCode',
            packContainerWeight: 'forms.fields.packContainerWeight',
            weightIncludesParts: 'forms.fields.weightIncludesParts',
            netWeightPerPack: 'forms.fields.netWeightPerPack',
            skidContainerCode: 'forms.fields.skidContainerCode',
            skidContainerWeight: 'forms.fields.skidContainerWeight',
            netWeightPerSkid: 'forms.fields.netWeightPerSkid'
        },
        formDialogue: 'forms.formDialogue',
        formMappings: 'forms.formMappings',
        labels: {
            baseForm: 'forms.labels.baseForm',
            pickandpack: 'forms.labels.pickandpack',
            csf: 'forms.labels.csf',
            mosiac: 'forms.labels.mosiac',
            form: 'forms.labels.form',
            group: 'forms.labels.group',
            print: 'forms.labels.print',
            screen: 'forms.labels.screen',
            storage: 'forms.labels.storage',
            setAsDefault: 'forms.labels.setAsDefault',
            typeDate: 'forms.labels.typeDate',
            typeTime: 'forms.labels.typeTime',
            typeDecimal: 'forms.labels.typeDecimal',
            typeInteger: 'forms.labels.typeInteger',
            typeMultiString: 'forms.labels.typeMultiString',
            typeString: 'forms.labels.typeString',
            typeTable: 'forms.labels.typeTable',
            wizard: 'forms.labels.wizard',
            packingSlip: 'forms.labels.packingSlip',
            deliveryNote: 'forms.labels.deliveryNote',
            addToCatalog: 'forms.labels.addToCatalog',
            updateCatalog: 'forms.labels.updateCatalog',
            itemDetails: 'forms.labels.itemDetails',
            general: 'forms.labels.general',
            physicalAttributes: 'forms.labels.physicalAttributes',
            pricingDetails: 'forms.labels.pricingDetails',
            packagingDetails: 'forms.labels.packagingDetails',
            packContainer: 'forms.labels.packContainer',
            skidContainer: 'forms.labels.skidContainer',
            netPrice: 'forms.labels.netPrice',
            chargesOrDiscounts: 'forms.labels.chargesOrDiscounts',
            charges: 'forms.labels.charges',
            discount: 'forms.labels.discount',
            tax: 'forms.labels.tax',
            vendorPartNumber: 'forms.labels.vendorPartNumber',
            action: 'forms.labels.action'
        },
        messages: {
            copyFormTitle: 'forms.messages.copyFormTitle',
            copyFormMessage: 'forms.messages.copyFormMessage',
            deleteDraftTitle: 'forms.messages.deleteDraftTitle',
            deleteDraftMessage: 'forms.messages.deleteDraftMessage',
            deleteFormTitle: 'forms.messages.deleteFormTitle',
            deleteFormMessage: 'forms.messages.deleteFormMessage',
            deleteMappingsPrompt: 'forms.messages.deleteMappingsPrompt',
            deleteSingleMappingPrompt: 'forms.messages.deleteSingleMappingPrompt',
            errorSavingMappings: () => {
                return {
                    key: 'forms.messages.errorSavingMappings',
                    paramsMap: ['message']
                };
            },
            formSavedSuccess: 'forms.messages.formSavedSuccess',
            importFormMessage: 'forms.messages.importFormMessage',
            importCsvSupportFile: 'forms.messages.importCsvSupportFile',
            importFormTitle: 'forms.messages.importFormTitle',
            leaveDirtyForm: 'forms.messages.leaveDirtyForm',
            saveChangesMessage: 'forms.messages.saveChangesMessage',
            saveChangesTitle: 'forms.messages.saveChangesTitle',
            unsavedChanges: 'forms.messages.unsavedChanges',
            leave: 'forms.messages.leave',
            stay: 'forms.messages.stay',
            importCatalogueTitle: 'forms.messages.importCatalogueTitle',
            catalogueUpdationFailed: 'forms.messages.catalogueUpdationFailed'
        },
        noDoc: 'forms.noDoc',
        outbox: 'forms.outbox',
        printReady: 'forms.printReady',
        submissions: 'forms.submissions',
        builder: 'forms.builder',
        validations: {
            formFieldRequired: 'forms.validations.formFieldRequired',
            csfFieldRequired: 'forms.validations.csfFieldRequired',
            sourceFieldRequired: 'forms.validations.sourceFieldRequired',
            targetFieldRequired: 'forms.validations.targetFieldRequired'
        },
        viewForm: 'forms.viewForm'
    },
    shipmentLabel: {
        copyTemplateDesc: 'shipmentLabel.copyTemplateDesc',
        copyTemplate: 'shipmentLabel.copyTemplate',
        deleteButton: 'shipmentLabel.deleteButton',
        copyButton: 'shipmentLabel.copyButton',
        deleteLabel: 'shipmentLabel.deleteLabel',
        deleteConfirm: 'shipmentLabel.deleteConfirm',
        labelNotFoundMessage: 'shipmentLabel.labelNotFoundMessage',
        title: 'shipmentLabel.title',
        saveAsDraft: 'shipmentLabel.saveAsDraft',
        addRow: 'shipmentLabel.addRow',
        addZone: 'shipmentLabel.addZone',
        savedAsDraft: 'shipmentLabel.savedAsDraft',
        prev: 'shipmentLabel.prev',
        next: 'shipmentLabel.next',
        labelName: 'shipmentLabel.labelName',
        typeOfLabel: 'shipmentLabel.typeOfLabel',
        senderId: 'shipmentLabel.senderId',
        receiverId: 'shipmentLabel.receiverId',
        storage: 'shipmentLabel.storage',
        storageType: 'shipmentLabel.storageType',
        generalInstruction: 'shipmentLabel.generalInstruction',
        unitOfMeasure: 'shipmentLabel.unitOfMeasure',
        labelHeight: 'shipmentLabel.labelHeight',
        labelWidth: 'shipmentLabel.labelWidth',
        noOfRows: 'shipmentLabel.noOfRows',
        rowHeight: 'shipmentLabel.rowHeight',
        noOfZones: 'shipmentLabel.noOfZones',
        prereqInfo: 'shipmentLabel.prereqInfo',
        labelLayout: 'shipmentLabel.labelLayout',
        zoneLayout: 'shipmentLabel.zoneLayout',
        zoneDataAndAssignment: 'shipmentLabel.zoneDataAndAssignment',
        finishLabel: 'shipmentLabel.finishLabel',
        rowSelection: 'shipmentLabel.rowSelection',
        zoneSelection: 'shipmentLabel.zoneSelection',
        zoneContent: 'shipmentLabel.zoneContent',
        zone: 'shipmentLabel.zone',
        zoneWidth: 'shipmentLabel.zoneWidth',
        zoneHeading: 'shipmentLabel.zoneHeading',
        fontFamily: 'shipmentLabel.fontFamily',
        fontSize: 'shipmentLabel.fontSize',
        fontWeight: 'shipmentLabel.fontWeight',
        margins: 'shipmentLabel.margins',
        mappedField: 'shipmentLabel.mappedField',
        contentDataType: 'shipmentLabel.contentDataType',
        barcodeType: 'shipmentLabel.barcodeType',
        height: 'shipmentLabel.height',
        width: 'shipmentLabel.width',
        left: 'shipmentLabel.left',
        top: 'shipmentLabel.top',
        hideZoneHeading: 'shipmentLabel.hideZoneHeading',
        addZoneHeading: 'shipmentLabel.addZoneHeading',
        addContent: 'shipmentLabel.addContent',
        publish: 'shipmentLabel.publish',
        imageSizeErrorMsg: 'shipmentLabel.imageSizeErrorMsg',
        barcode: 'shipmentLabel.barcode',
        text: 'shipmentLabel.text',
        image: 'shipmentLabel.image',
        borderType: 'shipmentLabel.borderType',
        borderDirection: 'shipmentLabel.borderDirection',
        right: 'shipmentLabel.right',
        bottom: 'shipmentLabel.bottom',
        borderWidth: 'shipmentLabel.borderWidth',
        hide: 'shipmentLabel.hide',
        dotted: 'shipmentLabel.dotted',
        dashed: 'shipmentLabel.dashed',
        solid: 'shipmentLabel.solid',
        double: 'shipmentLabel.double',
        groove: 'shipmentLabel.groove',
        ridge: 'shipmentLabel.ridge',
        inset: 'shipmentLabel.inset',
        outset: 'shipmentLabel.outset',
        labelSaveFailed: 'shipmentLabel.labelSaveFailed',
        labelPublishedSuccess: 'shipmentLabel.labelPublishedSuccess',
        labelDraftSuccess: 'shipmentLabel.labelDraftSuccess',
        shipmentLabelNInfo: 'shipmentLabel.shipmentLabelNInfo',
        mandatoryFieldsinImport: 'shipmentLabel.mandatoryFieldsinImport',
        formTemplateUnavailable: 'shipmentLabel.formTemplateUnavailable',
        hideOption: 'shipmentLabel.hideOption',
        showOption: 'shipmentLabel.showOption',
        overflow: 'shipmentLabel.overflow'
    },
    orderHub: {
        fields: {
            customerName: 'orderHub.fields.customerName',
            shipTo: 'orderHub.fields.shipTo',
            partNumber: 'orderHub.fields.partNumber',
            status: 'orderHub.fields.status',
            type: 'orderHub.fields.type',
            quantityToShip: 'orderHub.fields.quantityToShip',
            quantityShipped: 'orderHub.fields.quantityShipped',
            quantityRequired: 'orderHub.fields.quantityRequired',
            deliveryDate: 'orderHub.fields.deliveryDate',
            createdAt: 'orderHub.fields.createdAt',
            updatedAt: 'orderHub.fields.updatedAt'
        },
        orderDetails: 'orderHub.orderDetails',
        documentInfo: 'orderHub.documentInfo',
        noDataFound: 'orderHub.noDataFound',
        loading: 'orderHub.loading',
        deleteTitle: 'orderHub.deleteTitle',
        deleteMessage: 'orderHub.deleteMessage',
        deleteButton: 'orderHub.deleteButton',
        cancelButton: 'orderHub.cancelButton',
        totalBuyers: 'orderHub.totalBuyers',
        totalPartNumbers: 'orderHub.totalPartNumbers',
        eventHistory: 'orderHub.eventHistory',
        noEventsFound: 'orderHub.noEventsFound',
        today: 'orderHub.today',
        thisWeek: 'orderHub.thisWeek',
        thisMonth: 'orderHub.thisMonth'
    },
    pickAndPack: {
        invalidLineItemProperties: 'pickAndPack.invalidLineItemProperties',
        packShipment: 'pickAndPack.packShipment',
        preview: 'pickAndPack.preview',
        itemsToBePacked: 'pickAndPack.itemsToBePacked',
        autoPack: 'pickAndPack.autoPack',
        pack: 'pickAndPack.pack',
        split: 'pickAndPack.split',
        containerPalletReturnable: 'pickAndPack.containerPalletReturnable',
        chooseContainerPallet: 'pickAndPack.chooseContainerPallet',
        cancel: 'pickAndPack.cancel',
        totalQty: 'pickAndPack.totalQty',
        qtyRemaining: 'pickAndPack.qtyRemaining',
        qtyUnit: 'pickAndPack.qtyUnit',
        noItemsToDisplay: 'pickAndPack.noItemsToDisplay',
        container: 'pickAndPack.container',
        pallet: 'pickAndPack.pallet',
        type: 'pickAndPack.type',
        Yes: 'pickAndPack.Yes',
        No: 'pickAndPack.No',
        shipmentNumber: 'pickAndPack.shipmentNumber',
        shipmentDate: 'pickAndPack.shipmentDate',
        totalWeight: 'pickAndPack.totalWeight',
        totalVolume: 'pickAndPack.totalVolume',
        itemIsAlreadyPacked: 'pickAndPack.itemIsAlreadyPacked',
        packedItemsCannotBeDeleted: 'pickAndPack.packedItemsCannotBeDeleted',
        delete: 'pickAndPack.delete',
        operators: {
            numeric: {
                greaterThan: 'pickAndPack.operators.numeric.greaterThan',
                lessThan: 'pickAndPack.operators.numeric.lessThan',
                equalTo: 'pickAndPack.operators.numeric.equalTo',
                notEqualTo: 'pickAndPack.operators.numeric.notEqualTo'
            },
            nonNumeric: {
                contains: 'pickAndPack.operators.nonNumeric.contains',
                doesNotContains: 'pickAndPack.operators.nonNumeric.doesNotContains',
                equals: 'pickAndPack.operators.nonNumeric.equals',
                doesNotEqual: 'pickAndPack.operators.nonNumeric.doesNotEqual',
                startsWith: 'pickAndPack.operators.nonNumeric.startsWith',
                endsWith: 'pickAndPack.operators.nonNumeric.endsWith'
            }
        },
        labels: {
            addToPallet: 'pickAndPack.labels.addToPallet',
            containerPalletReturnable: 'pickAndPack.labels.containerPalletReturnable',
            existingPalletId: 'pickAndPack.labels.existingPalletId',
            cancel: 'pickAndPack.labels.cancel',
            add: 'pickAndPack.labels.add',
            pack: 'pickAndPack.labels.pack',
            addReturnableItems: 'pickAndPack.labels.addReturnableItems',
            addRow: 'pickAndPack.labels.addRow',
            itemName: 'pickAndPack.labels.itemName',
            qty: 'pickAndPack.labels.qty',
            packAllInOne: 'pickAndPack.labels.packAllInOne',
            appliedToAll: 'pickAndPack.labels.appliedToAll',
            selectItem: 'pickAndPack.labels.selectItem'
        },
        column: {
            srNo: 'pickAndPack.column.srNo',
            sscc: 'pickAndPack.column.sscc',
            labelNumber: 'pickAndPack.column.labelNumber',
            type: 'pickAndPack.column.type',
            itemPartNumber: 'pickAndPack.column.itemPartNumber',
            itemName: 'pickAndPack.column.itemName',
            quantity: 'pickAndPack.column.quantity',
            uom: 'pickAndPack.column.uom',
            innerboxQty: 'pickAndPack.column.innerboxQty',
            supplierPartNumber: 'pickAndPack.column.supplierPartNumber',
            buyerPartNumber: 'pickAndPack.column.buyerPartNumber',
            returnable: 'pickAndPack.column.returnable',
            palletId: 'pickAndPack.column.palletId',
            packedPalletId: 'pickAndPack.column.packedPalletId',
            showHideAll: 'pickAndPack.column.showHideAll'
        },
        errMsgs: {
            isReturnableRequired: 'pickAndPack.errMsgs.isReturnableRequired',
            selectItemRequired: 'pickAndPack.errMsgs.selectItemRequired',
            quantityRequired: 'pickAndPack.errMsgs.quantityRequired',
            onlyIntegerAllowed: 'pickAndPack.errMsgs.onlyIntegerAllowed',
            containerTypeRequired: 'pickAndPack.errMsgs.containerTypeRequired',
            typeRequired: 'pickAndPack.errMsgs.typeRequired',
            splitQuantityRequired: 'pickAndPack.errMsgs.splitQuantityRequired',
            invalidInput: 'pickAndPack.errMsgs.invalidInput',
            returnableValueRequired: 'pickAndPack.errMsgs.returnableValueRequired',
            qtyToPackReq: 'pickAndPack.errMsgs.qtyToPackReq',
            invalidQtyInput: 'pickAndPack.errMsgs.invalidQtyInput',
            onlyNumericValuesReq: 'pickAndPack.errMsgs.onlyNumericValuesReq',
            onlyPositiveValuesAllowed: 'pickAndPack.errMsgs.onlyPositiveValuesAllowed',
            enterdValueAlreadyAssigned: 'pickAndPack.errMsgs.enterdValueAlreadyAssigned'
        }
    },
    packAndLabel: {
        compact: 'packAndLabel.compact',
        standard: 'packAndLabel.standard',
        addToPallet: 'packAndLabel.addToPallet',
        noItemsToDisplay: 'packAndLabel.noItemsToDisplay',
        cancel: 'packAndLabel.cancel',
        type: 'packAndLabel.type',
        palletReturnable: 'packAndLabel.palletReturnable',
        Yes: 'packAndLabel.Yes',
        No: 'packAndLabel.No',
        errMsgs: {
            invalidPalletId: 'packAndLabel.errMsgs.invalidPalletId',
            typeIsRequired: 'packAndLabel.errMsgs.typeIsRequired',
            cannotPackIntoVirtualContainer: 'packAndLabel.errMsgs.cannotPackIntoVirtualContainer'
        }
    },
    groupPreferences: {
        addConfiguration: 'groupPreferences.addConfiguration',
        createNewConfig: 'groupPreferences.createNewConfig',
        deleteConfiguration: 'groupPreferences.deleteConfiguration',
        deleteMessage: 'groupPreferences.deleteMessage',
        deleteMessageConfirmation: 'groupPreferences.deleteMessageConfirmation',
        documentType: 'groupPreferences.documentType',
        durationInHours: 'groupPreferences.durationInHours',
        partnerError: 'groupPreferences.partnerError',
        durationHours: 'groupPreferences.durationHours',
        durationExceed: 'groupPreferences.durationExceed',
        groupPref: 'groupPreferences.groupPref',
        faOverdue: 'groupPreferences.faOverdue',
        partnerIds: 'groupPreferences.partnerIds',
        previouslyCreated: 'groupPreferences.previouslyCreated',
        selectAllPartner: 'groupPreferences.selectAllPartner',
        shippingLabelConfig: 'groupPreferences.shippingLabelConfig',
        supplierNumber: 'groupPreferences.supplierNumber',
        extensionNumber: 'groupPreferences.extensionNumber',
        serialNumber: 'groupPreferences.serialNumber',
        bolValue: 'groupPreferences.bolValue',
        psValue: 'groupPreferences.psValue',
        dnValue: 'groupPreferences.dnValue',
        ssccValue: 'groupPreferences.ssccValue',
        selectPartner: 'groupPreferences.selectPartner',
        triggerDuration: 'groupPreferences.triggerDuration'
    },
    presets: {
        addNewWidget: 'presets.addNewWidget',
        alphanumeric: 'presets.alphanumeric',
        title: 'presets.title',
        changeColor: 'presets.changeColor',
        clearSearch: 'presets.clearSearch',
        deletePreset: 'presets.deletePreset',
        duplicateName: 'presets.duplicateName',
        deleteWarning: 'presets.deleteWarning',
        filterWarning: 'presets.filterWarning',
        global: 'presets.global',
        limitError: 'presets.limitError',
        sharePreset: 'presets.sharePreset',
        saveEmptyPreset: 'presets.saveEmptyPreset',
        savePreset: 'presets.savePreset',
        saveFilterPreset: 'presets.saveFilterPreset',
        name: 'presets.name',
        presetError: 'presets.presetError',
        presetForbiddenError: 'presets.presetForbiddenError',
        presetMessage: 'presets.presetMessage',
        presetName: 'presets.presetName',
        presetPublicError: 'presets.presetPublicError',
        private: 'presets.private',
        public: 'presets.public',
        system: 'presets.system',
        filterScope: 'presets.filterScope',
        publicFilter: 'presets.publicFilter',
        resultsNumber: 'presets.resultsNumber',
        appliedFilters: 'presets.appliedFilters',
        selectPreset: 'presets.selectPreset',
        sharedFilter: 'presets.sharedFilter',
        appliesToScreen: 'presets.appliesToScreen',
        scope: 'presets.scope',
        showSmartFolder: 'presets.showSmartFolder',
        smartFolderName: 'presets.smartFolderName',
        customFolder: 'presets.customFolder',
        smartFolderValidation: 'presets.smartFolderValidation',
        systemFilter: 'presets.systemFilter',
        systemFilterError: 'presets.systemFilterError',
        systemFilterEditError: 'presets.systemFilterEditError',
        systemFilterHelper: 'presets.systemFilterHelper',
        privateFilterEditError: 'presets.privateFilterEditError',
        publicFilterEditError: 'presets.publicFilterEditError',
        filterCreatedPrivate: 'presets.filterCreatedPrivate',
        removeSmartFolder: 'presets.removeSmartFolder',
        presetHeader: 'presets.presetHeader',
        filterDialog: 'presets.filterDialog',
        outbound: 'presets.outbound',
        owner: 'presets.owner',
        inbound: 'presets.inbound'
    },
    users: {
        title: 'users.title',
        apiFailureMessage: 'users.apiFailureMessage',
        sidebarTitle: 'users.sidebarTitle',
        createUser: 'users.createUser',
        deleteUser: 'users.deleteUser',
        deletePrompt: 'users.deletePrompt',
        fields: {
            ID: 'users.fields.ID',
            email: 'users.fields.email',
            firstName: 'users.fields.firstName',
            lastName: 'users.fields.lastName',
            displayName: 'users.fields.displayName',
            role: 'users.fields.role',
            group: 'users.fields.group',
            timezone: 'users.fields.timezone',
            active: 'users.fields.active',
            langPref: 'users.fields.langPref',
            lastLogin: 'users.fields.lastLogin',
            militaryTimeFormat: 'users.fields.militaryTimeFormat',
            timeFormat: 'users.fields.timeFormat',
            zone: 'users.fields.zone',
            profilePicture: 'users.fields.profilePicture',
            password: 'users.fields.password',
            updatePassword: 'users.fields.updatePassword',
            confrmPasswrdUpdationMessage: 'users.fields.confrmPasswrdUpdationMessage'
        },
        subscribedToAlertPrompt: 'users.subscribedToAlertPrompt',
        subscribedToAlertDialogTitle: 'users.subscribedToAlertDialogTitle',
        validations: {
            emailWrong: 'users.validations.emailWrong',
            fNameRequired: 'users.validations.fNameRequired',
            lNameRequired: 'users.validations.lNameRequired',
            emailRequired: 'users.validations.emailRequired',
            groupRequired: 'users.validations.groupRequired',
            roleRequired: 'users.validations.roleRequired',
            groupLimitExhausted: 'users.validations.groupLimitExhausted'
        },
        userPreferences: 'users.userPreferences',
        noFeaturesAvailable: 'users.noFeaturesAvailable'
    },
    partnerGroups: {
        title: 'partnerGroups.title',
        fields: {
            ID: 'partnerGroups.fields.ID',
            groupId: 'partnerGroups.fields.groupId',
            name: 'partnerGroups.fields.name',
            role: 'partnerGroups.fields.role',
            import: 'partnerGroups.fields.import',
            export: 'partnerGroups.fields.export'
        }
    },
    clearingPartners: {
        title: 'clearingPartners.title',
        fields: {
            partnerId: 'clearingPartners.fields.partnerId',
            partnerGroupName: 'clearingPartners.fields.partnerGroupName',
            direction: 'clearingPartners.fields.direction',
            msgType: 'clearingPartners.fields.msgType',
            setup: 'clearingPartners.fields.setup',
            type: 'clearingPartners.fields.type',
            version: 'clearingPartners.fields.version',
            setId: 'clearingPartners.fields.setId',
            clearingLocation: 'clearingPartners.fields.clearingLocation',
            groupLocation: 'clearingPartners.fields.groupLocation',
            groupScenario: 'clearingPartners.fields.groupScenario',
            matchedConfigurations: 'clearingPartners.fields.matchedConfigurations',
            createdAt: 'clearingPartners.fields.createdAt',
            subset: 'clearingPartners.fields.subset'
        }
    },
    partners: {
        createPartner: 'partners.createPartner',
        clearValue: 'partners.clearValue',
        filterValuePlaceHolder: 'partners.filterValuePlaceHolder',
        title: 'partners.title',
        myOrganizationProfile: 'partners.myOrganizationProfile',
        tableMenus: {
            Delete: 'partners.tableMenus.delete',
            Copy: 'partners.tableMenus.copy',
            ExportPartner: 'partners.tableMenus.exportPartner',
            ImportPartner: 'partners.tableMenus.importPartner',
            Publish: 'partners.tableMenus.publish'
        },
        unSavedChangesDialog: {
            title: 'partners.unSavedChangesDialog.title',
            dialogContent: 'partners.unSavedChangesDialog.dialogContent'
        },
        profileInformation: {
            AcceptedLogoFileSize: 'partners.profileInformation.acceptedLogoFileSize',
            AddCompanyLogo: 'partners.profileInformation.addCompanyLogo',
            ViewCompanyLogo: 'partners.profileInformation.viewCompanyLogo',
            DragAndDropText: 'partners.profileInformation.dragAndDropText',
            buttons: {
                AddType: 'partners.profileInformation.buttons.addType',
                AddCompanyLogo: 'partners.profileInformation.buttons.addCompanyLogo',
                AddAddress: 'partners.profileInformation.buttons.addAddress',
                Apply: 'partners.profileInformation.buttons.apply',
                Close: 'partners.profileInformation.buttons.close',
                Change: 'partners.profileInformation.buttons.change',
                Remove: 'partners.profileInformation.buttons.remove',
                Delete: 'partners.profileInformation.buttons.delete',
                Next: 'partners.profileInformation.buttons.next',
                Upload: 'partners.profileInformation.buttons.upload',
                Cancel: 'partners.profileInformation.buttons.cancel',
                Update: 'partners.profileInformation.buttons.update',
                Add: 'partners.profileInformation.buttons.add',
                SaveAsDraft: 'partners.profileInformation.buttons.saveAsDraft',
                CreatePartner: 'partners.profileInformation.buttons.createPartner',
                addPartner: 'partners.profileInformation.buttons.addPartner',
                UpdatePartner: 'partners.profileInformation.buttons.updatePartner'
            },
            addNewPartnerTitle: 'partners.profileInformation.addNewPartnerTitle',
            updatePartnerTitle: 'partners.profileInformation.updatePartnerTitle',
            updateOrganizationProfile: 'partners.profileInformation.updateOrganizationProfile',
            fields: {
                PartnerName: 'partners.profileInformation.fields.partnerName',
                PartnerType: 'partners.profileInformation.fields.partnerType',
                RoleType: 'partners.profileInformation.fields.roleType',
                Language: 'partners.profileInformation.fields.language',
                UserName: 'partners.profileInformation.fields.userName',
                PhoneNumber: 'partners.profileInformation.fields.phoneNumber',
                EmailId: 'partners.profileInformation.fields.emailId',
                IsdCode: 'partners.profileInformation.fields.isdCode',
                Addresses: 'partners.profileInformation.fields.addresses',
                AddressType: 'partners.profileInformation.fields.addressType',
                ThisIsPrimaryAddress: 'partners.profileInformation.fields.thisIsPrimaryAddress',
                AddressLine: 'partners.profileInformation.fields.addressLine',
                City: 'partners.profileInformation.fields.city',
                State: 'partners.profileInformation.fields.state',
                Street: 'partners.profileInformation.fields.street',
                Country: 'partners.profileInformation.fields.country',
                ZipCode: 'partners.profileInformation.fields.zipCode',
                SalesForceId: 'partners.profileInformation.fields.SalesForceId',
                PartnerId: 'partners.profileInformation.fields.PartnerId'
            },
            formatError: 'partners.profileInformation.formatError',
            addressTypeoptions: {
                BillTo: 'partners.profileInformation.addressTypeoptions.billto',
                ShipTo: 'partners.profileInformation.addressTypeoptions.shipto',
                ShipFrom: 'partners.profileInformation.addressTypeoptions.shipfrom',
                Supplier: 'partners.profileInformation.addressTypeoptions.supplier'
            },
            partnerTypeoptions: {
                X12: 'partners.profileInformation.partnerTypeoptions.x12',
                EDIFACT: 'partners.profileInformation.partnerTypeoptions.edifact',
                VDA: 'partners.profileInformation.partnerTypeoptions.vda',
                TRADACOMS: 'partners.profileInformation.partnerTypeoptions.tradacoms',
                WEBEDI: 'partners.profileInformation.partnerTypeoptions.webedi',
                Ecommerce: 'partners.profileInformation.partnerTypeoptions.ecommerce',
                Routing: 'partners.profileInformation.partnerTypeoptions.routing',
                Inhouse: 'partners.profileInformation.partnerTypeoptions.inhouse'
            },
            partnerLogoUploadPage: {},
            roleTypeoptions: {
                Buyer: 'partners.profileInformation.roleTypeoptions.buyer',
                Supplier: 'partners.profileInformation.roleTypeoptions.supplier'
            },
            languageOptions: {
                English: 'partners.profileInformation.languageOptions.english',
                German: 'partners.profileInformation.languageOptions.german'
            },
            steeperButtons: {
                profileInformation: 'partners.profileInformation.steeperButtons.profileInformation',
                identifiers: 'partners.profileInformation.steeperButtons.identifiers',
                messageActivation: 'partners.profileInformation.steeperButtons.messageActivation'
            },
            basicInformation: 'partners.profileInformation.basicInformation'
        },
        delete: 'partners.delete',
        deleteConfirmDialog: {
            delete: 'partners.deleteConfirmDialog.delete',
            description: 'partners.deleteConfirmDialog.description',
            title: 'partners.deleteConfirmDialog.title'
        },
        tooltips: {
            edit: 'partners.tooltips.edit',
            delete: 'partners.tooltips.delete',
            cancel: 'partners.tooltips.cancel',
            add: 'partners.tooltips.add',
            notSyncedWithBackend: 'partners.tooltips.notSyncedWithBackend'
        },
        editOrSave: 'partners.editOrSave',
        identifier: {
            addIdentifierButton: 'partners.identifier.addIdentifierButton',
            tableHeaders: {
                characterSetType: 'partners.identifier.tableHeaders.characterSetType',
                interchangeQualifier: 'partners.identifier.tableHeaders.interchangeQualifier',
                isaId: 'partners.identifier.tableHeaders.isaId',
                isaQualifier: 'partners.identifier.tableHeaders.isaQualifier',
                isaVersion: 'partners.identifier.tableHeaders.isaVersion',
                usageIndicator: 'partners.identifier.tableHeaders.usageIndicator',
                acknowledgmentRequested: 'partners.identifier.tableHeaders.acknowledgmentRequested',
                gsId: 'partners.identifier.tableHeaders.gsId',
                gsVersion: 'partners.identifier.tableHeaders.gsVersion',
                syntaxIdentifier: 'partners.identifier.tableHeaders.syntaxIdentifier',
                syntaxVersion: 'partners.identifier.tableHeaders.syntaxVersion',
                refType: 'partners.identifier.tableHeaders.refType',
                unoa: 'partners.identifier.tableHeaders.unoa',
                unob: 'partners.identifier.tableHeaders.unob',
                unoc: 'partners.identifier.tableHeaders.unoc',
                interchangeId: 'partners.identifier.tableHeaders.interchangeId'
            }
        },
        messageActivation: {
            addMessageActivationBtn: 'partners.messageActivation.addMessageActivationBtn',
            addMessageActivationTitle: 'partners.messageActivation.addMessageActivationTitle',
            updateMessageActivationTitle: 'partners.messageActivation.updateMessageActivationTitle',
            commonFieldsCaption: 'partners.messageActivation.commonFieldsCaption',
            partnerListInfo: 'partners.messageActivation.partnerListInfo',
            validationError: 'partners.messageActivation.validationError',
            duplicateEntryError: () => {
                return {
                    key: 'partners.messageActivation.duplicateEntryError',
                    paramsMap: ['partner', 'documentType', 'direction']
                };
            },
            duplicateDocumentTypesError: () => {
                return {
                    key: 'partners.messageActivation.duplicateDocumentTypesError',
                    paramsMap: ['documentTypes']
                };
            },
            tabItems: {
                inbound: () => ({
                    key: 'partners.messageActivation.tabItems.inbound',
                    paramsMap: ['partnerName']
                }),
                outbound: () => ({
                    key: 'partners.messageActivation.tabItems.outbound',
                    paramsMap: ['partnerName']
                })
            },
            tableHeaders: {
                configuredPartner: 'partners.messageActivation.tableHeaders.configuredPartner',
                activationType: 'partners.messageActivation.tableHeaders.activationType',
                documentType: 'partners.messageActivation.tableHeaders.documentType',
                ediVersion: 'partners.messageActivation.tableHeaders.ediVersion',
                converterMap: 'partners.messageActivation.tableHeaders.converterMap',
                genrateAutoackn: 'partners.messageActivation.tableHeaders.genrateAutoackn',
                senderInterchangeQualifier:
                    'partners.messageActivation.tableHeaders.senderInterchangeQualifier',
                senderInterchangeID: 'partners.messageActivation.tableHeaders.senderInterchangeID',
                receiverInterchangeQualifier:
                    'partners.messageActivation.tableHeaders.receiverInterchangeQualifier',
                receiverInterchangeID:
                    'partners.messageActivation.tableHeaders.receiverInterchangeID',
                senderFunctionalID: 'partners.messageActivation.tableHeaders.senderFunctionalID',
                receiverFunctionalID:
                    'partners.messageActivation.tableHeaders.receiverFunctionalID',
                internalReference: 'partners.messageActivation.tableHeaders.internalReference'
            }
        },
        fields: {
            ID: 'partners.fields.ID',
            partnerId: 'partners.fields.partnerId',
            name: 'partners.fields.name',
            group: 'partners.fields.group',
            email: 'partners.fields.email',
            phone: 'partners.fields.phone',
            fax: 'partners.fields.fax',
            status: 'partners.fields.status',
            salesForceId: 'partners.fields.salesForceId',
            organizationId: 'partners.fields.organizationId',
            country: 'partners.fields.country',
            state: 'partners.fields.state',
            turnAroundEnabled: 'partners.fields.turnAroundEnabled',
            editAttribute: 'partners.fields.editAttribute',
            enableTurnAround: 'partners.fields.enableTurnAround',
            type: 'partners.fields.type'
        }
    },
    transactions: {
        title: 'transactions.title',
        noRuleAvailable: 'transactions.noRuleAvailable',
        fields: {
            ID: 'transactions.fields.ID',
            orderID: 'transactions.fields.orderID',
            senderID: 'transactions.fields.senderID'
        },
        labelsWithData: {
            date: () => {
                return {
                    key: 'transactions.labelsWithData.date',
                    paramsMap: ['date']
                };
            },
            document: () => {
                return {
                    key: 'transactions.labelsWithData.document',
                    paramsMap: ['document']
                };
            },
            id: () => {
                return {
                    key: 'transactions.labelsWithData.id',
                    paramsMap: ['id']
                };
            },
            orderID: () => {
                return {
                    key: 'transactions.labelsWithData.orderID',
                    paramsMap: ['orderID']
                };
            },
            reference: () => {
                return {
                    key: 'transactions.labelsWithData.reference',
                    paramsMap: ['reference']
                };
            },
            sender: () => {
                return {
                    key: 'transactions.labelsWithData.sender',
                    paramsMap: ['sender']
                };
            },
            senderID: () => {
                return {
                    key: 'transactions.labelsWithData.senderID',
                    paramsMap: ['senderID']
                };
            }
        },
        sorting: {
            sortBy: 'transactions.sorting.sortBy',
            started: 'transactions.sorting.started',
            updated: 'transactions.sorting.updated',
            lastEvent: 'transactions.sorting.lastEvent'
        },
        documentPhases: {
            purchase: 'transactions.documentPhases.purchase',
            invoice: 'transactions.documentPhases.invoice',
            warehouse: 'transactions.documentPhases.warehouse',
            logistic: 'transactions.documentPhases.logistic'
        },
        trackAndTrace: {
            selectRuleButton: 'transactions.trackAndTrace.selectRuleButton',
            selectRuleLabel: 'transactions.trackAndTrace.selectRuleLabel',
            configuredRules: 'transactions.trackAndTrace.configuredRules',
            view: 'transactions.trackAndTrace.view',
            dateTime: 'transactions.trackAndTrace.dateTime',
            referenceId: 'transactions.trackAndTrace.referenceId',
            senderId: 'transactions.trackAndTrace.senderId',
            receiverId: 'transactions.trackAndTrace.receiverId',
            partnerGroup: 'transactions.trackAndTrace.partnerGroup',
            documentCount: 'transactions.trackAndTrace.documentCount',
            lifecycleDetails: 'transactions.trackAndTrace.lifecycleDetails'
        }
    },
    activities: {
        singleTitle: 'activities.singleTitle',
        title: 'activities.title',
        sorting: {
            sortBy: 'activities.sorting.sortBy',
            date: 'activities.sorting.date'
        },
        status: {
            success: 'activities.status.success',
            error: 'activities.status.error'
        },
        fields: {
            CdxName: 'activities.fields.CdxName',
            InternalGroupId: 'activities.fields.InternalGroupId',
            CdxCreatedAt: 'activities.fields.CdxCreatedAt',
            CdxActivityId: 'activities.fields.CdxActivityId',
            restartHistory: 'activities.fields.restartHistory',
            status: 'activities.fields.status'
        },
        activityDetails: 'activities.activityDetails',
        alertMessage: 'activities.alertMessage',
        basicDetails: 'activities.basicDetails',
        linkedActivities: 'activities.linkedActivities',
        newActivity: 'activities.newActivity',
        oldActivity: 'activities.oldActivity',
        dateNTime: 'activities.dateNTime',
        documentCount: 'activities.documentCount',
        filename: 'activities.filename',
        internalGroupID: 'activities.internalGroupID',
        internalGroupName: 'activities.internalGroupName',
        filterActivities: 'activities.filterActivities',
        ok: 'activities.ok',
        restartAlert: 'activities.restartAlert',
        restartConfirmation: 'activities.restartConfirmation',
        restartInitiated: 'activities.restartInitiated',
        restartComplete: 'activities.restartComplete',
        restartFailed: 'activities.restartFailed',
        restartEvents: 'activities.restartEvents',
        restarting: 'activities.restarting',
        restarted: 'activities.restarted',
        restart: 'activities.restart',
        errorTitle: 'activities.errorTitle',
        showErrorActivities: 'activities.showErrorActivities',
        count: () => {
            return {
                key: 'activities.count',
                paramsMap: ['count']
            };
        },
        activityDetailedLogs: {
            dateTime: 'activities.activityDetailedLogs.dateTime',
            trace: 'activities.activityDetailedLogs.trace',
            shortMessage: 'activities.activityDetailedLogs.shortMessage',
            statusCode: 'activities.activityDetailedLogs.statusCode',
            title: 'activities.activityDetailedLogs.title'
        },
        activityRestartToastMessage: 'activities.activityRestartToastMessage',
        activitySuccessToastMessage: activityId => {
            return {
                key: 'activities.activitySuccessToastMessage',
                paramsMap: ['activityId']
            };
        },
        activityFailureToastMessage: activityId => {
            return {
                key: 'activities.activityFailureToastMessage',
                paramsMap: ['activityId']
            };
        },
        activityRestartInitiateToastMessage: 'activities.activityRestartInitiateToastMessage'
    },
    apiIntegration: {
        title: 'apiIntegration.title',
        list: {
            name: 'apiIntegration.list.name',
            type: 'apiIntegration.list.type',
            description: 'apiIntegration.list.description',
            customerGroup: 'apiIntegration.list.customerGroup',
            customerAppStatus: 'apiIntegration.list.customerAppStatus',
            pollingInterval: 'apiIntegration.list.pollingInterval',
            status: 'apiIntegration.list.status',
            createdAt: 'apiIntegration.list.createdAt',
            createdBy: 'apiIntegration.list.createdBy',
            updatedAt: 'apiIntegration.list.updatedAt',
            updatedBy: 'apiIntegration.list.updatedBy'
        },
        addTitle: 'apiIntegration.addTitle',
        form: {
            section: {
                storeInformation: 'apiIntegration.form.section.storeInformation',
                accessTokenGeneration: 'apiIntegration.form.section.accessTokenGeneration',
                sqsUrl: 'apiIntegration.form.section.sqsUrl',
                getFile: 'apiIntegration.form.section.getFile',
                updateStatus: 'apiIntegration.form.section.updateStatus',
                partnerInformation: 'apiIntegration.form.section.partnerInformation',
                b2bRouterInfo: 'apiIntegration.form.section.b2bRouterInfo',
                addApiIntegrationPartner: 'apiIntegration.form.section.addApiIntegrationPartner',
                editApiIntegrationPartner: 'apiIntegration.form.section.editApiIntegrationPartner',
                add: 'apiIntegration.form.section.add',
                update: 'apiIntegration.form.section.update',
                active: 'apiIntegration.form.section.active',
                inactive: 'apiIntegration.form.section.inactive',
                successfullyUpdated: 'apiIntegration.form.section.successfullyUpdated',
                successfullyCreated: 'apiIntegration.form.section.successfullyCreated'
            },
            field: {
                url: 'apiIntegration.form.field.url',
                type: 'apiIntegration.form.field.type',
                clientId: 'apiIntegration.form.field.clientId',
                clientSecret: 'apiIntegration.form.field.clientSecret',
                grantType: 'apiIntegration.form.field.grantType',
                username: 'apiIntegration.form.field.username',
                password: 'apiIntegration.form.field.password',

                accessTokenNumber: 'apiIntegration.form.field.accessTokenNumber',
                shopifyConnector: 'apiIntegration.form.field.shopifyConnector',
                offsetId: 'apiIntegration.form.field.offsetId',
                storeId: 'apiIntegration.form.field.storeId',
                locationId: 'apiIntegration.form.field.locationId',
                authorization: 'apiIntegration.form.field.authorization',
                token: 'apiIntegration.form.field.token',
                requestParams: 'apiIntegration.form.field.requestParams',
                requestHeader: 'apiIntegration.form.field.requestHeader',
                correlationID: 'apiIntegration.form.field.correlationID',
                tenantId: 'apiIntegration.form.field.tenantId',
                partnerName: 'apiIntegration.form.field.partnerName',
                pollingInterval: 'apiIntegration.form.field.pollingInterval',
                customerGroup: 'apiIntegration.form.field.customerGroup',
                unitOfMeasure: 'apiIntegration.form.field.unitOfMeasure',
                description: 'apiIntegration.form.field.description',

                sqsFederationUrl: 'apiIntegration.form.field.sqsFederationUrl',
                sqsUrl: 'apiIntegration.form.field.sqsUrl',
                visibilityTimeout: 'apiIntegration.form.field.visibilityTimeout',
                batchSize: 'apiIntegration.form.field.batchSize',
                waitTimeSeconds: 'apiIntegration.form.field.waitTimeSeconds',

                keyName: 'apiIntegration.form.field.keyName',
                keyValue: 'apiIntegration.form.field.keyValue',

                b2bAccountId: 'apiIntegration.form.field.b2bAccountId',
                apiKeys: 'apiIntegration.form.field.apiKeys',
                country: 'apiIntegration.form.field.country',
                identifierNumber: 'apiIntegration.form.field.identifierNumber',
                webhookSecret: 'apiIntegration.form.field.webhookSecret'
            },
            validationSuccess: 'apiIntegration.form.validationSuccess'
        }
    },
    ecommerceStore: {
        title: 'ecommerceStore.title',
        createEcommerceStore: 'ecommerceStore.createEcommerceStore',
        deleteEcommerceStore: 'ecommerceStore.deleteEcommerceStore',
        dialogOkay: 'ecommerceStore.dialogOkay',
        createMessage: 'ecommerceStore.createMessage',
        deleteMessage: 'ecommerceStore.deleteMessage',
        createDialogTitle: 'ecommerceStore.createDialogTitle',
        editStore: 'ecommerceStore.editStore',
        editDialogTitle: 'ecommerceStore.editDialogTitle',
        deletePrompt: 'ecommerceStore.deletePrompt',
        fields: {
            active: 'ecommerceStore.fields.active',
            inActive: 'ecommerceStore.fields.inActive',
            shopify: 'ecommerceStore.fields.shopify',
            bestBuy: 'ecommerceStore.fields.bestBuy',
            amazon: 'ecommerceStore.fields.amazon'
        },
        labels: {
            storeName: 'ecommerceStore.labels.storeName',
            ecommercePlatform: 'ecommerceStore.labels.ecommercePlatform',
            ecommerceDescription: 'ecommerceStore.labels.ecommerceDescription',
            ecommerceAccessToken: 'ecommerceStore.labels.ecommerceAccessToken',
            storeId: 'ecommerceStore.labels.storeId',
            activity: 'ecommerceStore.labels.activity',
            validate: 'ecommerceStore.labels.validate',
            customerGroup: 'ecommerceStore.labels.customerGroup',
            locationId: 'ecommerceStore.labels.locationId',
            offset: 'ecommerceStore.labels.offset'
        }
    },

    roles: {
        title: 'roles.title',
        createOutboundForm: 'roles.createOutboundForm',
        createRole: 'roles.createRole',
        revertChanges: 'roles.revertChanges',
        saveChanges: 'roles.saveChanges',
        roleList: 'roles.roleList',
        deletePrompt: 'roles.deletePrompt',
        deleteRole: 'roles.deleteRole',
        fields: {
            ID: 'roles.fields.ID',
            name: 'roles.fields.name',
            ownerName: 'roles.fields.ownerName',
            groupName: 'roles.fields.groupName',
            usersCount: 'roles.fields.usersCount',
            createdAt: 'roles.fields.createdAt',
            updatedAt: 'roles.fields.updatedAt'
        },
        labels: {
            partnerGroup: 'roles.labels.partnerGroup',
            organizationIDs: 'roles.labels.organizationIDs',
            requestCode: 'roles.labels.requestCode',
            documentFilters: 'roles.labels.documentFilters',
            envelopeEditingURL: 'roles.labels.envelopeEditingURL',
            documentContent: 'roles.labels.documentContent',
            exportDocument: 'roles.labels.exportDocument',
            documentCount: 'roles.labels.documentCount',
            documentSource: 'roles.labels.documentSource',
            systemNotifications: 'roles.labels.systemNotifications',
            users: 'roles.labels.users',
            groups: 'roles.labels.groups',
            impersonateUser: 'roles.labels.impersonateUser',
            impersonateGroup: 'roles.labels.impersonateGroup',
            clusters: 'roles.labels.clusters',
            roles: 'roles.labels.roles',
            documents: 'roles.labels.documents',
            documentSets: 'roles.labels.documentSets',
            activities: 'roles.labels.activities',
            addNewRole: 'roles.labels.addNewRole',
            aliases: 'roles.labels.aliases',
            billing: 'roles.labels.billing',
            manageAlerts: 'roles.labels.manageAlerts',
            notificationCenter: 'roles.labels.notificationCenter',
            systemNotification: 'roles.labels.systemNotification',
            none: 'roles.labels.none',
            view: 'roles.labels.view',
            modify: 'roles.labels.modify',
            newRole: 'roles.labels.newRole',
            emailError: 'roles.labels.emailError',
            turnAround: 'roles.labels.turnAround',
            outboundForm: 'roles.labels.outboundForm',
            reprocessDocument: 'roles.labels.reprocessDocument',
            resendDocument: 'roles.labels.resendDocument',
            restartActivity: 'roles.labels.restartActivity',
            generateAcknowledgement: 'roles.labels.generateAcknowledgement',
            eInvoicing: 'roles.labels.eInvoicing',
            shipmentLabel: 'roles.labels.shipmentLabel',
            packingSlip: 'roles.labels.packingSlip',
            bol: 'roles.labels.bol',
            deliveryNote: 'roles.labels.deliveryNote',
            containerLabel: 'roles.labels.containerLabel',
            masterLabel: 'roles.labels.masterLabel',
            mixedLabel: 'roles.labels.mixedLabel',
            destinationLabel: 'roles.labels.destinationLabel',
            archiveRetentionDocument: 'roles.labels.archiveRetentionDocument'
        },
        messages: {
            groupsNotPermitted: 'roles.messages.groupsNotPermitted',
            roleUpdated: 'roles.messages.roleUpdated',
            usersNotPermitted: 'roles.messages.usersNotPermitted'
        }
    },
    groups: {
        title: 'groups.title',
        createGroup: 'groups.createGroup',
        tableView: 'groups.tableView',
        treeView: 'groups.treeView',
        sidebarTitle: 'groups.sidebarTitle',
        deleteGroup: 'groups.deleteGroup',
        deletePrompt: 'groups.deletePrompt',
        addDocumentFilter: 'groups.addDocumentFilter',
        deleteDocumentFilter: 'groups.deleteDocumentFilter',
        fields: {
            ID: 'groups.fields.ID',
            name: 'groups.fields.name',
            features: 'groups.fields.features',
            parentGroup: 'groups.fields.parentGroup',
            defaultRole: 'groups.fields.defaultRole',
            organisationId: 'groups.fields.organisationId',
            partnerId: 'groups.fields.partnerId',
            partnerGroup: 'groups.fields.partnerGroup',
            organisationIdFlag: 'groups.fields.organisationIdFlag',
            partnerGroupFlag: 'groups.fields.partnerGroupFlag',
            requestCode: 'groups.fields.requestCode',
            passwordExpiryPolicy: 'groups.fields.passwordExpiryPolicy',
            dailyLimitLabel: 'groups.fields.dailyLimitLabel',
            limitResetMessage: 'groups.fields.limitResetMessage',
            dailyLimitMessage: 'groups.fields.dailyLimitMessage',
            mfa: 'groups.fields.mfa',
            inherit: 'groups.fields.inherit',
            enable: 'groups.fields.enable',
            disabled: 'groups.fields.disabled',
            supportGroup: 'groups.fields.supportGroup',
            groupLimit: 'groups.fields.groupLimit',
            partnerLimit: 'groups.fields.partnerLimit',
            groupType: 'groups.fields.groupType',
            customerRelationships: 'groups.fields.customerRelationships'
        },
        externalPartner: 'groups.externalPartner',
        erpPartner: 'groups.erpPartner',
        nonCustomer: 'groups.nonCustomer',
        // groupTypeRequired: 'groups.groupTypeRequired',
        organizationGroup: 'groups.organizationGroup',
        ssoToggle: 'groups.ssoToggle',
        ssoLoginType: 'groups.ssoLoginType',
        ssoClientID: 'groups.ssoClientID',
        ssoOrganisationURL: 'groups.ssoOrganisationURL',
        ssoClientRequired: 'groups.ssoClientRequired',
        ssoOrgURLRequired: 'groups.ssoOrgURLRequired',
        ssoLoginTypeRequired: 'groups.ssoLoginTypeRequired',
        eventLogsToggle: 'groups.eventLogsToggle',
        eventLogs: {
            fields: {
                enabled: 'groups.eventLogs.fields.enabled',
                active: 'groups.eventLogs.fields.active',
                sendToExternal: 'groups.eventLogs.fields.sendToExternal',
                typeOfEvents: 'groups.eventLogs.fields.typeOfEvents',
                apiEndpoint: 'groups.eventLogs.fields.apiEndpoint',
                apiMethod: 'groups.eventLogs.fields.apiMethod',
                authenticationMethod: 'groups.eventLogs.fields.authenticationMethod',
                username: 'groups.eventLogs.fields.username',
                password: 'groups.eventLogs.fields.password',
                grantType: 'groups.eventLogs.fields.grantType',
                clientId: 'groups.eventLogs.fields.clientId',
                clientSecret: 'groups.eventLogs.fields.clientSecret',
                scope: 'groups.eventLogs.fields.scope',
                accessTokenUrl: 'groups.eventLogs.fields.accessTokenUrl'
            },
            validation: {
                apiEndpointRequired: 'groups.eventLogs.validation.apiEndpointRequired',
                apiEndpointMaxLength: 'groups.eventLogs.validation.apiEndpointMaxLength',
                apiMethodRequired: 'groups.eventLogs.validation.apiMethodRequired',
                authenticationMethodRequired:
                    'groups.eventLogs.validation.authenticationMethodRequired',
                usernameRequired: 'groups.eventLogs.validation.usernameRequired',
                passwordRequired: 'groups.eventLogs.validation.passwordRequired',
                grantTypeRequired: 'groups.eventLogs.validation.grantTypeRequired',
                clientIdRequired: 'groups.eventLogs.validation.clientIdRequired',
                clientSecretRequired: 'groups.eventLogs.validation.clientSecretRequired',
                accessTokenUrlRequired: 'groups.eventLogs.validation.accessTokenUrlRequired'
            }
        },
        mfaEnable: 'groups.mfaEnable',
        customerRelationshipPartnerCapacityRequired: () => {
            return {
                key: 'groups.customerRelationshipPartnerCapacityRequired',
                paramsMap: ['customerRelationship']
            };
        },
        customerRelationshipPartnerCapacityExhausted: () => {
            return {
                key: 'groups.customerRelationshipPartnerCapacityExhausted',
                paramsMap: ['customerRelationship']
            };
        },
        groupTypeError: () => {
            return {
                key: 'groups.groupTypeError',
                paramsMap: ['groupNames']
            };
        },
        validation: {
            nameRequired: 'groups.validation.nameRequired',
            orgGroupRequired: 'groups.validation.orgGroupRequired',
            parentGroupRequired: 'groups.validation.parentGroupRequired',
            groupTypeRequired: 'groups.validation.groupTypeRequired',
            defaultRoleRequired: 'groups.validation.defaultRoleRequired',
            onlyInteger: 'groups.validation.onlyInteger',
            nonZeroPositiveValuesRequired: 'groups.validation.nonZeroPositiveValuesRequired',
            customerRelationshipsFieldRequired:
                'groups.validation.customerRelationshipsFieldRequired',
            partnerCapacityFieldRequired: 'groups.validation.partnerCapacityFieldRequired',
            customerGroupHierarchyExists: 'groups.validation.customerGroupHierarchyExists'
        },
        validationError: 'groups.validationError',
        documentFilters: 'groups.documentFilters'
    },
    table: {
        addColumns: 'table.addColumns',
        showColumns: 'table.showColumns',
        search: 'table.search',
        refresh: 'table.refresh',
        profile: 'table.profile',
        clearValue: 'table.clearValue',
        previousPage: 'table.previousPage',
        nextPage: 'table.nextPage',
        firstPage: 'table.firstPage',
        lastPage: 'table.lastPage',
        tooltips: {
            readBy: () => {
                return {
                    key: 'table.tooltips.readBy',
                    paramsMap: ['users']
                };
            },
            readAllTooltip: 'table.tooltips.readAllTooltip'
        },
        read: 'table.read',
        unread: 'table.unread',
        archived: 'table.archived'
    },
    aliases: {
        alerts: {
            exportSuccess: 'aliases.alerts.exportSuccess',
            invalidFileFormat: 'aliases.alerts.invalidFileFormat',
            uploadSuccess: 'aliases.alerts.uploadSuccess'
        },
        aliasesDictionary: 'aliases.aliasesDictionary',
        exportAliases: {
            alias: 'aliases.exportAliases.alias',
            aliasGivenByParent: 'aliases.exportAliases.aliasGivenByParent',
            id: 'aliases.exportAliases.id',
            partnerName: 'aliases.exportAliases.partnerName'
        },
        updateMessage: 'aliases.updateMessage',
        display: 'aliases.display',
        partner: 'aliases.partner',
        aliases: 'aliases.aliases',
        showUntitled: 'aliases.showUntitled',
        dialog: {
            tabs: {
                myOrgIds: 'aliases.dialog.tabs.myOrgIds',
                myPartners: 'aliases.dialog.tabs.myPartners',
                senderReceiver: 'aliases.dialog.tabs.senderReceiver',
                type: 'aliases.dialog.tabs.type',
                stage: 'aliases.dialog.tabs.stage',
                partnerGroups: 'aliases.dialog.tabs.partnerGroups',
                otherPartners: 'aliases.dialog.tabs.otherPartners'
            }
        },
        fields: {
            id: 'aliases.fields.id',
            alias: 'aliases.fields.alias',
            inheritedAlias: 'aliases.fields.inheritedAlias',
            partnerName: 'aliases.fields.partnerName'
        },
        exportButton: 'aliases.exportButton',
        importButton: 'aliases.importButton'
    },
    audits: {
        title: 'audits.title',
        export: 'audits.export',
        fields: {
            title: 'audits.fields.title',
            date: 'audits.fields.date',
            operationType: 'audits.fields.operationType',
            key: 'audits.fields.key',
            initiator: 'audits.fields.initiator',
            createdAt: 'audits.fields.createdAt',
            createdBy: 'audits.fields.createdBy',
            updatedAt: 'audits.fields.updatedAt',
            updatedBy: 'audits.fields.updatedBy',
            deletedAt: 'audits.fields.deletedAt',
            deletedBy: 'audits.fields.deletedBy',
            data: {
                name: 'audits.fields.data.name',
                parameter: 'audits.fields.data.parameter',
                oldValue: 'audits.fields.data.oldValue',
                newValue: 'audits.fields.data.newValue',
                added: 'audits.fields.data.added',
                removed: 'audits.fields.data.removed',
                value: 'audits.fields.data.value'
            }
        }
    },
    crossReference: {
        add: 'crossReference.add',
        addRow: 'crossReference.addRow',
        addSingeRow: 'crossReference.addSingeRow',
        addMultiple: 'crossReference.addMultiple',
        alreadyExist: 'crossReference.alreadyExist',
        alreadyExistIdentifier: 'crossReference.alreadyExistIdentifier',
        buttonContinue: 'crossReference.buttonContinue',
        buttonTryAgain: 'crossReference.buttonTryAgain',
        clear: 'crossReference.clear',
        createdOn: 'crossReference.createdOn',
        createTable: 'crossReference.createTable',
        createButtom: 'crossReference.createButtom',
        clearTable: 'crossReference.clearTable',
        clearTableData: 'crossReference.clearTableData',
        clearTableMessage: 'crossReference.clearTableMessage',
        clearMessage: 'crossReference.clearMessage',
        column: 'crossReference.column',
        confirmImport: 'crossReference.confirmImport',
        delimeterCharacter: 'crossReference.delimeterCharacter',
        delimiterSelection: 'crossReference.delimiterSelection',
        dataPublish: 'crossReference.dataPublish',
        dataType: 'crossReference.dataType',
        deleteRow: 'crossReference.deleteRow',
        description: 'crossReference.description',
        downloadTemplate: 'crossReference.downloadTemplate',
        dragDrop: 'crossReference.dragDrop',
        deleteWarningTitle: 'crossReference.deleteWarningTitle',
        deleteWarning: 'crossReference.deleteWarning',
        duplicateColumns: 'crossReference.duplicateColumns',
        duplicateKeyMessage: 'crossReference.duplicateKeyMessage',
        duplicateKeyCsvMessage: 'crossReference.duplicateKeyCsvMessage',
        editData: 'crossReference.editData',
        editSchema: 'crossReference.editSchema',
        editTableMessage: 'crossReference.editTableMessage',
        emptyTableMessage: 'crossReference.emptyTableMessage',
        group: 'crossReference.group',
        identifier: 'crossReference.identifier',
        import: 'crossReference.import',
        importFailed: 'crossReference.importFailed',
        importFailedMessage: 'crossReference.importFailedMessage',
        importMessage: 'crossReference.importMessage',
        importWarning: 'crossReference.importWarning',
        keyFields: 'crossReference.keyFields',
        limitExceed: 'crossReference.limitExceed',
        name: 'crossReference.name',
        newTable: 'crossReference.newTable',
        NoTable: 'crossReference.NoTable',
        number: 'crossReference.number',
        numberDataType: 'crossReference.numberDataType',
        or: 'crossReference.or',
        publish: 'crossReference.publish',
        requiredField: 'crossReference.requiredField',
        requiredName: 'crossReference.requiredName',
        rowLimit: 'crossReference.rowLimit',
        select: 'crossReference.select',
        selectMultiple: 'crossReference.selectMultiple',
        size: 'crossReference.size',
        tableCreationAlert: () => {
            return {
                key: 'crossReference.tableCreationAlert',
                paramsMap: ['tableName']
            };
        },
        tableUpdationAlert: () => {
            return {
                key: 'crossReference.tableUpdationAlert',
                paramsMap: ['tableName']
            };
        },
        identifierHelperText: 'crossReference.identifierHelperText',
        StringHelperText: 'crossReference.StringHelperText',
        NumberHelperText: 'crossReference.NumberHelperText',
        spaceCharIdentifier: 'crossReference.spaceCharIdentifier',
        tableDefinition: 'crossReference.tableDefinition',
        title: 'crossReference.title',
        unpublishItem: 'crossReference.unpublishItem',
        unpublishItemAlert: 'crossReference.unpublishItemAlert',
        updatedOn: 'crossReference.updatedOn',
        updateTable: 'crossReference.updateTable',
        updateValidationError: 'crossReference.updateValidationError',
        value: 'crossReference.value',
        valueField: 'crossReference.valueField',
        wrongDataType: 'crossReference.wrongDataType'
    },
    billing: {
        billingStatus: 'billing.billingStatus',
        browse: 'billing.browse',
        browseLabel: 'billing.browseLabel',
        upload: 'billing.upload',
        formatError: 'billing.formatError',
        label: 'billing.label',
        validate: 'billing.validate',
        title: 'billing.title',
        fetchTransaction: 'billing.fetchTransaction',
        fetchAllTransaction: 'billing.fetchAllTransaction',
        fetchCustomerTransaction: 'billing.fetchCustomerTransaction',
        showInvalidTransactions: 'billing.showInvalidTransactions',
        emptyInvalidTransactionTypes: 'billing.emptyInvalidTransactionTypes',
        emptyInvalidTransactions: 'billing.emptyInvalidTransactions',
        processTransaction: 'billing.processTransaction',
        exportAs: 'billing.exportAs',
        csv: 'billing.csv',
        pdf: 'billing.pdf',
        customerInfo: 'billing.customerInfo',
        transactions: 'billing.transactions',
        usage: 'billing.usage',
        exportSuccess: 'billing.exportSuccess',
        csvInvalidRows: 'billing.csvInvalidRows',
        csvAllRowsValid: 'billing.csvAllRowsValid',
        allValidRows: 'billing.allValidRows',
        validationResults: 'billing.validationResults',
        failedTransactions: 'billing.failedTransactions',
        transactionsType: 'billing.transactionsType',
        failedAlert: 'billing.failedAlert',
        inProgressMsg: () => {
            return {
                key: 'billing.inProgressMsg',
                paramsMap: ['startDateTime']
            };
        },
        transactionCount: () => {
            return {
                key: 'billing.transactionCount',
                paramsMap: ['transactionCounts']
            };
        },
        europe: 'billing.europe',
        northAmerica: 'billing.northAmerica',
        exportBillingUsage: 'billing.exportBillingUsage',
        exportValidateTransactions: 'billing.exportValidateTransactions',
        region: 'billing.region',
        transactionValidated: 'billing.transactionValidated',
        transactionProcessed: 'billing.transactionProcessed',
        fields: {
            sfReportRowId: 'billing.fields.sfReportRowId',
            usageContractId: 'billing.fields.usageContractId',
            reportDate: 'billing.fields.reportDate',
            serviceContractId: 'billing.fields.serviceContractId',
            accountName: 'billing.fields.accountName',
            usageType: 'billing.fields.usageType',
            productCode: 'billing.fields.productCode',
            productName: 'billing.fields.productName',
            productDescription: 'billing.fields.productDescription',
            usageLineBlob: 'billing.fields.usageLineBlob',
            quantity: 'billing.fields.quantity',
            usageFeeCurrency: 'billing.fields.usageFeeCurrency',
            usageFee: 'billing.fields.usageFee',
            netTotalCurrency: 'billing.fields.netTotalCurrency',
            netTotal: 'billing.fields.netTotal',
            effStartDate: 'billing.fields.effStartDate',
            effEndDate: 'billing.fields.effEndDate',
            validationStatus: 'billing.fields.validationStatus',
            partnerActivityId: 'billing.fields.partnerActivityId',
            lastChangeDate: 'billing.fields.lastChangeDate',
            mosfilesId: 'billing.fields.mosfilesId',
            opportunityName: 'billing.fields.opportunityName',
            partnerReference: 'billing.fields.partnerReference',
            partnerName: 'billing.fields.partnerName',
            externalNr: 'billing.fields.externalNr',
            modifier: 'billing.fields.modifier',
            direction: 'billing.fields.direction',
            mosfilesRef: 'billing.fields.mosfilesRef',
            mandant: 'billing.fields.mandant',
            usergroupName: 'billing.fields.usergroupName',
            testFlag: 'billing.fields.testFlag',
            cc: 'billing.fields.cc',
            edi7: 'billing.fields.edi7',
            mandantReference: 'billing.fields.mandantReference',
            messageCount: 'billing.fields.messageCount',
            signedId: 'billing.fields.signedId',
            id: 'billing.fields.id',
            name: 'billing.fields.name',
            characterCount: 'billing.fields.characterCount',
            createActivity: 'billing.fields.createActivity',
            product: 'billing.fields.product'
        }
    },
    chart: {
        accepted: 'chart.accepted',
        activities: 'chart.activities',
        activitiesInError: 'chart.activitiesInError',
        bottom10: 'chart.bottom10',
        documents: 'chart.documents',
        filtered: 'chart.filtered',
        quantity: 'chart.quantity',
        rejected: 'chart.rejected',
        sender: 'chart.sender',
        top10: 'chart.top10',
        total: 'chart.total',
        types: {
            bar: 'chart.types.bar',
            line: 'chart.types.line',
            pie: 'chart.types.pie'
        },
        unknown: 'chart.unknown'
    },
    customSubscriptions: {
        active: 'customSubscriptions.active',
        addSubscription: 'customSubscriptions.addSubscription',
        alertName: 'customSubscriptions.alertName',
        always: 'customSubscriptions.always',
        change: 'customSubscriptions.change',
        countCriteria: 'customSubscriptions.countCriteria',
        countCriteriaValues: {
            less: 'customSubscriptions.countCriteriaValues.less',
            greater: 'customSubscriptions.countCriteriaValues.greater',
            equal: 'customSubscriptions.countCriteriaValues.equal'
        },
        countValue: 'customSubscriptions.countValue',
        critical: 'customSubscriptions.critical',
        days: {
            friday: 'customSubscriptions.days.friday',
            monday: 'customSubscriptions.days.monday',
            saturday: 'customSubscriptions.days.saturday',
            sunday: 'customSubscriptions.days.sunday',
            thursday: 'customSubscriptions.days.thursday',
            tuesday: 'customSubscriptions.days.tuesday',
            wednesday: 'customSubscriptions.days.wednesday'
        },
        defaultMessage: 'customSubscriptions.defaultMessage',
        deleteAlert: 'customSubscriptions.deleteAlert',
        deletePrompt: 'customSubscriptions.deletePrompt',
        description: 'customSubscriptions.description',
        disabled: 'customSubscriptions.disabled',
        duration: 'customSubscriptions.duration',
        editAlertTitle: 'customSubscriptions.editAlertTitle',
        emailMessage: 'customSubscriptions.emailMessage',
        emailHelperMessage: 'customSubscriptions.emailHelperMessage',
        emailSubject: 'customSubscriptions.emailSubject',
        enabled: 'customSubscriptions.enabled',
        endDate: 'customSubscriptions.endDate',
        error: 'customSubscriptions.error',
        every: 'customSubscriptions.every',
        fields: {
            endDate: 'customSubscriptions.fields.endDate',
            filterName: 'customSubscriptions.fields.filterName',
            lastModifiedDate: 'customSubscriptions.fields.lastModifiedDate',
            notificationName: 'customSubscriptions.fields.notificationName',
            occurrence: 'customSubscriptions.fields.occurrence',
            status: 'customSubscriptions.fields.status'
        },
        filterCustomSubscriptions: 'customSubscriptions.filterCustomSubscriptions',
        filterIdError: 'customSubscriptions.filterIdError',
        filters: 'customSubscriptions.filters',
        emailDeliveryMode: 'customSubscriptions.emailDeliveryMode',
        separateEmailWithSeparatePdf: 'customSubscriptions.separateEmailWithSeparatePdf',
        singleEmailWithMergedPdf: 'customSubscriptions.singleEmailWithMergedPdf',
        separateEmailWithSeparatePdfHelperText:
            'customSubscriptions.separateEmailWithSeparatePdfHelperText',
        singleEmailWithMergedPdfHelperText:
            'customSubscriptions.singleEmailWithMergedPdfHelperText',
        hour: 'customSubscriptions.hour',
        hours: 'customSubscriptions.hours',
        inactive: 'customSubscriptions.inactive',
        info: 'customSubscriptions.info',
        minute: 'customSubscriptions.minute',
        minutes: 'customSubscriptions.minutes',
        minutesExceed: 'customSubscriptions.minutesExceed',
        multiple: 'customSubscriptions.multiple',
        newAlertTitle: 'customSubscriptions.newAlertTitle',
        notificationMessage: 'customSubscriptions.notificationMessage',
        notificationNameError: 'customSubscriptions.notificationNameError',
        notificationNameDuplicateError: 'customSubscriptions.notificationNameDuplicateError',
        notificationNameServerError: 'customSubscriptions.notificationNameServerError',
        occurrence: {
            custom: 'customSubscriptions.occurrence.custom',
            everyDay: 'customSubscriptions.occurrence.everyDay',
            everyWeek: 'customSubscriptions.occurrence.everyWeek',
            everyMonth: 'customSubscriptions.occurrence.everyMonth'
        },
        priority: 'customSubscriptions.priority',
        privateFilter: 'customSubscriptions.privateFilter',
        recurrenceLabel: 'customSubscriptions.recurrenceLabel',
        schedule: {
            daily: () => {
                return {
                    key: 'customSubscriptions.schedule.daily',
                    paramsMap: ['time']
                };
            },
            weekly: () => {
                return {
                    key: 'customSubscriptions.schedule.weekly',
                    paramsMap: ['days', 'time']
                };
            },
            monthly: () => {
                return {
                    key: 'customSubscriptions.schedule.monthly',
                    paramsMap: ['days', 'time']
                };
            }
        },
        scheduleOccurrence: 'customSubscriptions.scheduleOccurrence',
        selectTime: 'customSubscriptions.selectTime',
        selectUsers: 'customSubscriptions.selectUsers',
        attachSource: 'customSubscriptions.attachSource',
        attachTarget: 'customSubscriptions.attachTarget',
        attachForm: 'customSubscriptions.attachForm',
        attachTrace: 'customSubscriptions.attachTrace',
        addSubscribers: 'customSubscriptions.addSubscribers',
        addEmailRecipients: 'customSubscriptions.addEmailRecipients',
        addCC: 'customSubscriptions.addCC',
        addBCC: 'customSubscriptions.addBCC',
        addUsersInCC: 'customSubscriptions.addUsersInCC',
        addUsersInBCC: 'customSubscriptions.addUsersInBCC',
        addCCRecipients: 'customSubscriptions.addCCRecipients',
        addBCCRecipients: 'customSubscriptions.addBCCRecipients',
        recipientHelperText: 'customSubscriptions.recipientHelperText',
        attachments: 'customSubscriptions.attachments',
        attachErrorLog: 'customSubscriptions.attachErrorLog',
        maxDocumentsInEmail: 'customSubscriptions.maxDocumentsInEmail',
        maxDocumentsInEmailTooltip: 'customSubscriptions.maxDocumentsInEmailTooltip',
        markAsDone: 'customSubscriptions.markAsDone',
        markAsDoneTooltip: 'customSubscriptions.markAsDoneTooltip',
        basicInformation: 'customSubscriptions.basicInformation',
        emailContent: 'customSubscriptions.emailContent',
        emailRecipients: 'customSubscriptions.emailRecipients',
        filtersAndTriggerRule: 'customSubscriptions.filtersAndTriggerRule',
        frequency: 'customSubscriptions.frequency',
        saveAlert: 'customSubscriptions.saveAlert',
        updateAlert: 'customSubscriptions.updateAlert',
        sendMaximumOf: 'customSubscriptions.sendMaximumOf',
        emailsPer: 'customSubscriptions.emailsPer',
        periodDay: 'customSubscriptions.periodDay',
        periodWeek: 'customSubscriptions.periodWeek',
        periodMonth: 'customSubscriptions.periodMonth',
        documentCount: 'customSubscriptions.documentCount',
        subFilter: 'customSubscriptions.subFilter',
        subFilterHelperText: 'customSubscriptions.subFilterHelperText',
        sorting: {
            date: 'customSubscriptions.sorting.date',
            sortBy: 'customSubscriptions.sorting.sortBy'
        },
        success: 'customSubscriptions.success',
        timePicker: 'customSubscriptions.timePicker',
        trigger: 'customSubscriptions.trigger',
        validation: {
            alertNameRequired: 'customSubscriptions.validation.alertNameRequired',
            allFieldsRequired: 'customSubscriptions.validation.allFieldsRequired',
            descriptionRequired: 'customSubscriptions.validation.descriptionRequired',
            emailMessageRequired: 'customSubscriptions.validation.emailMessageRequired',
            emailSubjectRequired: 'customSubscriptions.validation.emailSubjectRequired',
            endDateRequired: 'customSubscriptions.validation.endDateRequired',
            filterRequired: 'customSubscriptions.validation.filterRequired',
            frequencyRequired: 'customSubscriptions.validation.frequencyRequired',
            recurrenceRequired: 'customSubscriptions.validation.recurrenceRequired',
            timeRequired: 'customSubscriptions.validation.timeRequired',
            validCount: 'customSubscriptions.validation.validCount',
            maximumSubscribers: 'customSubscriptions.validation.maximumSubscribers',
            subjectVariablesNotAllowed: 'customSubscriptions.validation.subjectVariablesNotAllowed'
        },
        warning: 'customSubscriptions.warning'
    },
    dateRange: {
        customRange: 'dateRange.customRange',
        days: 'dateRange.days',
        interval: 'dateRange.interval',
        last: 'dateRange.last',
        months: 'dateRange.months',
        today: 'dateRange.today',
        thisMonth: 'dateRange.thisMonth',
        thisWeek: 'dateRange.thisWeek',
        weeks: 'dateRange.weeks',
        yesterday: 'dateRange.yesterday',
        dateValidationMsg: 'dateRange.dateValidationMsg'
    },
    documents: {
        fileUpload: {
            invalidFile: 'documents.fileUpload.invalidFile',
            fileSizeExceed: 'documents.fileUpload.fileSizeExceed',
            uploadFile: 'documents.fileUpload.uploadFile',
            browseFile: 'documents.fileUpload.browseFile',
            dragNdrop: 'documents.fileUpload.dragNdrop',
            csvJson: 'documents.fileUpload.csvJson',
            selectedFile: 'documents.fileUpload.selectedFile',
            upload: 'documents.fileUpload.upload',
            cancel: 'documents.fileUpload.cancel'
        },
        accepted: 'documents.accepted',
        acceptedError: 'documents.acceptedError',
        acceptedWarning: 'documents.acceptedWarning',
        alertMessage: 'documents.alertMessage',
        rejected: 'documents.rejected',
        overdue: 'documents.overdue',
        pending: 'documents.pending',
        submitted: 'documents.submitted',
        registered: 'documents.registered',
        refused: 'documents.refused',
        failed: 'documents.failed',
        partialAcc: 'documents.partialAcc',
        acknowledged: 'documents.acknowledged',
        complete: 'documents.complete',
        export: 'documents.export',
        done: 'documents.done',
        inprogressDoc: 'documents.inprogressDoc',
        import: 'documents.import',
        received: 'documents.received',
        partner: 'documents.partner',
        send: 'documents.send',
        error: 'documents.error',
        errorReported: 'documents.errorReported',
        inProgress: 'documents.inProgress',
        success: 'documents.success',
        activityLog: 'documents.activityLog',
        allDocuments_literal: 'documents.allDocuments_literal',
        basicInfo: 'documents.basicInfo',
        taxReportLifecycle: 'documents.taxReportLifecycle',
        noTaxReportEvents: 'documents.noTaxReportEvents',
        type: 'documents.type',
        binaryFileErrorMessage: 'documents.binaryFileErrorMessage',
        title: 'documents.title',
        sidebarTitle: 'documents.sidebarTitle',
        savePreset: 'documents.savePreset',
        deleteFilter: 'documents.deleteFilter',
        switchToChart: 'documents.switchToChart',
        switchToTable: 'documents.switchToTable',
        showDocument: 'documents.showDocument',
        expand: 'documents.expand',
        collapse: 'documents.collapse',
        refreshing: 'documents.refreshing',
        refreshComplete: 'documents.refreshComplete',
        inbox: 'documents.inbox',
        sent: 'documents.sent',
        all: 'documents.all',
        inboundFile: 'documents.inboundFile',
        outboundFile: 'documents.outboundFile',
        business: 'documents.business',
        technical: 'documents.technical',
        downloadAsOriginal: 'documents.downloadAsOriginal',
        downloadWithLineBreak: 'documents.downloadWithLineBreak',
        errorMessage: 'documents.errorMessage',
        downloadWithLineBreakMessage: 'documents.downloadWithLineBreakMessage',
        resend: 'documents.resend',
        resending: 'documents.resending',
        resendFailed: 'documents.resendFailed',
        reprocessInitiated: 'documents.reprocessInitiated',
        reprocessComplete: 'documents.reprocessComplete',
        reprocessing: 'documents.reprocessing',
        reprocessed: 'documents.reprocessed',
        resent: 'documents.resent',
        reprocessFailed: 'documents.reprocessFailed',
        resentSuccessfully: 'documents.resentSuccessfully',
        reprocessResendEvents: 'documents.reprocessResendEvents',
        reprocessResend: 'documents.reprocessResend',
        generateAcknowledgement: 'documents.generateAcknowledgement',
        ineligibleDocuments: 'documents.ineligibleDocuments',
        resendConfirmation: 'documents.resendConfirmation',
        resendAlert: 'documents.resendAlert',
        reprocessConfirmation: 'documents.reprocessConfirmation',
        reprocessAlert: 'documents.reprocessAlert',
        continueUsingEDX: 'documents.continueUsingEDX',
        linkedDocuments: 'documents.linkedDocuments',
        oldDocument: 'documents.oldDocument',
        newDocument: 'documents.newDocument',
        id: 'documents.id',
        initiateReprocessToastMessage: 'documents.initiateReprocessToastMessage',
        bulkRestartAlert: () => {
            return {
                key: 'documents.bulkRestartAlert',
                paramsMap: ['selActivities']
            };
        },
        bulkReprocessAlert: () => {
            return {
                key: 'documents.bulkReprocessAlert',
                paramsMap: ['reprocessDocCount', 'selectedDocCount']
            };
        },
        bulkResendAlert: () => {
            return {
                key: 'documents.bulkResendAlert',
                paramsMap: ['resendDocCount', 'selectedDocCount']
            };
        },
        reprocessSuccessToastMessage: 'documents.reprocessSuccessToastMessage',
        reprocessFailureToastMessage: 'documents.reprocessFailureToastMessage',
        resendToastMessage: 'documents.resendToastMessage',
        resendFailureToastMessage: 'documents.resendFailureToastMessage',
        generateAckSuccessMsg: 'documents.generateAckSuccessMsg',
        generateAckFailureMsg: 'documents.generateAckFailureMsg',
        ecommerceReprocessFailureFRS001: () => {
            return {
                key: 'documents.ecommerceReprocessFailureFRS001',
                paramsMap: ['documentId']
            };
        },
        ecommerceReprocessFailureFRS002: () => {
            return {
                key: 'documents.ecommerceReprocessFailureFRS002',
                paramsMap: ['documentId']
            };
        },
        ecommerceReprocessFailureFRS003: () => {
            return {
                key: 'documents.ecommerceReprocessFailureFRS003',
                paramsMap: ['documentId']
            };
        },
        ecommerceReprocessFailureFRS004: () => {
            return {
                key: 'documents.ecommerceReprocessFailureFRS004',
                paramsMap: ['documentId']
            };
        },
        summaryInformation: 'documents.summaryInformation',
        packingInformation: 'documents.packingInformation',
        fields: {
            ID: 'documents.fields.ID',
            interchange: 'documents.fields.interchange',
            dateTime: 'documents.fields.dateTime',
            sender: 'documents.fields.sender',
            setId: 'documents.fields.setId',
            format: 'documents.fields.format',
            receiver: 'documents.fields.receiver',
            parentIds: 'documents.fields.parentIds',
            ackStatus: 'documents.fields.ackStatus',
            partnerGroup: 'documents.fields.partnerGroup',
            document: 'documents.fields.document',
            type: 'documents.fields.type',
            reference: 'documents.fields.reference',
            stage: 'documents.fields.stage',
            status: 'documents.fields.status',
            edxId: 'documents.fields.edxId',
            direction: 'documents.fields.direction',
            relatedDocs: 'documents.fields.relatedDocs',
            ctrlNum1: 'documents.fields.ctrlNum1',
            ctrlNum2: 'documents.fields.ctrlNum2',
            ctrlNum3: 'documents.fields.ctrlNum3',
            connectionType: 'documents.fields.connectionType',
            appStatus: 'documents.fields.appStatus',
            faStatus: 'documents.fields.faStatus',
            expireAt: 'documents.fields.expireAt',
            taxReportStatus: 'documents.fields.taxReportStatus'
        },
        outOfScope: {
            message: 'documents.outOfScope.message',
            title: 'documents.outOfScope.title'
        },
        tooLarge: 'documents.tooLarge',
        viewForm: 'documents.viewForm',
        encoding: 'documents.encoding',
        viewSource: 'documents.viewSource',
        lineBreak: 'documents.lineBreak',
        charCount: 'documents.charCount',
        enterCharacter: 'documents.enterCharacter',
        enterCharCount: 'documents.enterCharCount',
        sequence: 'documents.sequence',
        documentsStage: 'documents.documentsStage',
        readAllMessage: 'documents.readAllMessage',
        readAllOkay: 'documents.readAllOkay',
        reply: 'documents.reply',
        turnarounds: 'documents.turnarounds',
        invoice: 'documents.invoice',
        dispatchAdvice: 'documents.dispatchAdvice',
        applicationAdvice: 'documents.applicationAdvice',
        orders: 'documents.orders',
        acknowledgement: 'documents.acknowledgement',
        orderChange: 'documents.orderChange',
        receivingAdvice: 'documents.receivingAdvice',
        shippingSchedule: 'documents.shippingSchedule',
        planningSchedule: 'documents.planningSchedule',
        priceCatalog: 'documents.priceCatalog',
        invetoryReport: 'documents.invetoryReport',
        advanceShipNotice: 'documents.advanceShipNotice',
        textMessage: 'documents.textMessage',
        warehouseShippingOrder: 'documents.warehouseShippingOrder',
        warehouseShippingAdvice: 'documents.warehouseShippingAdvice',
        remittanceAdvice: 'documents.remittanceAdvice',
        purchaseOrder: 'documents.purchaseOrder',
        showDetailedLogs: 'documents.showDetailedLogs',
        switchview: 'documents.switchview',
        quantity: 'documents.quantity',
        netAmount: 'documents.netAmount',
        presetMessage: 'documents.presetMessage',
        returns: 'documents.returns',
        documentSizeWarning: 'documents.documentSizeWarning',
        documentSizeWarningMessage: 'documents.documentSizeWarningMessage',
        loading: 'documents.loading',
        loadingIndicator: 'documents.loadingIndicator',
        proceed: 'documents.proceed',
        userAction: {
            inProgress: 'documents.userAction.inProgress',
            notNeeded: 'documents.userAction.notNeeded',
            pending: 'documents.userAction.pending',
            done: 'documents.userAction.done',
            doneAuto: 'documents.userAction.doneAuto',
            action: 'documents.userAction.action',
            changeActionStatus: 'documents.userAction.changeActionStatus',
            ok: 'documents.userAction.ok',
            contentDesc: 'documents.userAction.contentDesc',
            alertInfo: 'documents.userAction.alertInfo',
            automaticallyMarked: 'documents.userAction.automaticallyMarked',
            manuallyMarked: 'documents.userAction.manuallyMarked'
        },
        searchOptions: {
            searchOptionsLabel: 'documents.searchOptions.searchOptionsLabel',
            fullTextSearch: 'documents.searchOptions.fullTextSearch',
            advancedSearch: 'documents.searchOptions.advancedSearch',
            operator: 'documents.searchOptions.operator',
            and: 'documents.searchOptions.and',
            or: 'documents.searchOptions.or',
            referenceFieldLabel: 'documents.searchOptions.referenceFieldLabel',
            referenceFieldValue: 'documents.searchOptions.referenceFieldValue',
            addReferenceFieldButton: 'documents.searchOptions.addReferenceFieldButton',
            errorEmptyReferenceValue: 'documents.searchOptions.errorEmptyReferenceValue',
            errorDuplicateReferenceField: 'documents.searchOptions.errorDuplicateReferenceField',
            errorEmptyReferenceLabelField: 'documents.searchOptions.errorEmptyReferenceLabelField'
        }
    },
    userPreferences: {
        adminSection: {
            notifications: 'userPreferences.adminSection.notifications',
            userActivated: 'userPreferences.adminSection.userActivated',
            userDeactivated: 'userPreferences.adminSection.userDeactivated',
            userRegistered: 'userPreferences.adminSection.userRegistered'
        },
        appCustomization: {
            defaultDashboard: 'userPreferences.appCustomization.defaultDashboard',
            landingPage: 'userPreferences.appCustomization.landingPage',
            usePartnerNames: 'userPreferences.appCustomization.usePartnerNames',
            useDisplayNames: 'userPreferences.appCustomization.useDisplayNames'
        },
        title: 'userPreferences.title',
        profile: {
            title: 'userPreferences.profile.title',
            name: 'userPreferences.profile.name',
            group: 'userPreferences.profile.group',
            missingUserName: 'userPreferences.profile.missingUserName'
        },
        profilePictureUploaded: 'userPreferences.profilePictureUploaded',
        profilePictureRemoved: 'userPreferences.profilePictureRemoved',
        notifications: {
            documents: 'userPreferences.notifications.documents',
            documentProcessing: 'userPreferences.notifications.documentProcessing',
            inbound: 'userPreferences.notifications.inbound',
            outbound: 'userPreferences.notifications.outbound',
            user: 'userPreferences.notifications.user',
            userActivated: 'userPreferences.notifications.userActivated',
            userDeactivated: 'userPreferences.notifications.userDeactivated',
            sendEmailOnEcommerceError: 'userPreferences.notifications.sendEmailOnEcommerceError',
            sendEmailOnApiIntegrationError:
                'userPreferences.notifications.sendEmailOnApiIntegrationError',
            sendEmailOnDocumentProcessingError:
                'userPreferences.notifications.sendEmailOnDocumentProcessingError',
            ecommerce: 'userPreferences.notifications.ecommerce',
            apiIntegration: 'userPreferences.notifications.apiIntegration',
            sendEmailOnMFTDocumentProcessingError:
                'userPreferences.notifications.sendEmailOnMFTDocumentProcessingError',
            mft: 'userPreferences.notifications.mft'
        },
        changePassword: 'userPreferences.changePassword',
        dataFormat: 'userPreferences.dataFormat',
        editDisplayNames: 'userPreferences.editDisplayNames',
        resetSettings: 'userPreferences.resetSettings',
        sendEmailNotifications: 'userPreferences.sendEmailNotifications',
        changePasswordDialog: {
            title: 'userPreferences.changePasswordDialog.title',
            oldPassword: 'userPreferences.changePasswordDialog.oldPassword',
            newPassword: 'userPreferences.changePasswordDialog.newPassword',
            showPassword: 'userPreferences.changePasswordDialog.showPassword',
            hidePassword: 'userPreferences.changePasswordDialog.hidePassword',
            confirmPassword: 'userPreferences.changePasswordDialog.confirmPassword',
            errorMessages: {
                emptyFieldMessage:
                    'userPreferences.changePasswordDialog.errorMessages.emptyFieldMessage',
                weakPasswordMessage:
                    'userPreferences.changePasswordDialog.errorMessages.weakPasswordMessage',
                weakPasswordTooltipMessage:
                    'userPreferences.changePasswordDialog.errorMessages.weakPasswordTooltipMessage',
                weakUpdatePasswordTooltipMessage:
                    'userPreferences.changePasswordDialog.errorMessages.weakUpdatePasswordTooltipMessage',
                confirmPasswordMessage:
                    'userPreferences.changePasswordDialog.errorMessages.confirmPasswordMessage',
                oldNewPasswordSameMessage:
                    'userPreferences.changePasswordDialog.errorMessages.oldNewPasswordSameMessage'
            }
        },
        tabs: {
            accountSettings: 'userPreferences.tabs.accountSettings',
            notificationsSettings: 'userPreferences.tabs.notificationsSettings',
            adminSettings: 'userPreferences.tabs.adminSettings',
            appCustomization: 'userPreferences.tabs.appCustomization'
        },
        ssoUserPwdDisableMsg: 'userPreferences.ssoUserPwdDisableMsg'
    },
    userAgreement: {
        title: 'userAgreement.title'
    },
    profilePicture: {
        uploadProfilePic: 'profilePicture.uploadProfilePic',
        uploadProfilePicOne: 'profilePicture.uploadProfilePicOne',
        instructionOne: 'profilePicture.instructionOne',
        instructionTwo: 'profilePicture.instructionTwo',
        instructionThree: 'profilePicture.instructionThree',
        instructionFour: 'profilePicture.instructionFour',
        instructionFive: 'profilePicture.instructionFive',
        acceptedImgType: 'profilePicture.acceptedImgType',
        editPicture: 'profilePicture.editPicture',
        removePicture: 'profilePicture.removePicture',
        picUpdatedSuccessMsg: 'profilePicture.picUpdatedSuccessMsg',
        formatError: 'profilePicture.formatError'
    },
    documentSets: {
        switchToTable: 'documentSets.switchToTable',
        switchToForm: 'documentSets.switchToForm',
        errorTitle: 'documentSets.errorTitle',
        deliveryProgress: 'documentSets.deliveryProgress',
        deliveryStatus: 'documentSets.deliveryStatus',
        destination: 'documentSets.destination',
        shipmentID: 'documentSets.shipmentID',
        updated: 'documentSets.updated',
        estAppointments: 'documentSets.estAppointments',
        invoice: 'documentSets.invoice',
        mCLTender: 'documentSets.mCLTender',
        participants: 'documentSets.participants',
        carrierResponse: 'documentSets.carrierResponse',
        declineReason: 'documentSets.declineReason',
        assignedCarrier: 'documentSets.assignedCarrier',
        pickupLocation: 'documentSets.pickupLocation',
        shipmentDetails: 'documentSets.shipmentDetails',
        grossWeight: 'documentSets.grossWeight',
        grossVolume: 'documentSets.grossVolume',
        shipper: 'documentSets.shipper',
        DUNS: 'documentSets.DUNS',
        noDocumentSet: 'documentSets.noDocumentSet',
        somethingWentWrong: 'documentSets.somethingWentWrong'
    },
    documentSetFields: {
        configuration: 'documentSetFields.configuration',
        createdAt: 'documentSetFields.createdAt',
        createdBy: 'documentSetFields.createdBy',
        id: 'documentSetFields.id',
        lastModified: 'documentSetFields.lastModified',
        name: 'documentSetFields.name',
        updatedAt: 'documentSetFields.updatedAt',
        transactionId: 'documentSetFields.transactionId'
    },
    docLifecycleConfiguration: {
        createConfigTitle: 'docLifecycleConfiguration.createConfigTitle',
        editConfigTitle: 'docLifecycleConfiguration.editConfigTitle',
        title: 'docLifecycleConfiguration.title',
        deleteConfig: 'docLifecycleConfiguration.deleteConfig',
        deletePrompt: 'docLifecycleConfiguration.deletePrompt',
        createConfig: 'docLifecycleConfiguration.createConfig',
        fields: {
            configName: 'docLifecycleConfiguration.fields.configName',
            group: 'docLifecycleConfiguration.fields.group',
            phaseConfiguration: 'docLifecycleConfiguration.fields.phaseConfiguration',
            phaseSample: 'docLifecycleConfiguration.fields.phaseSample'
        },
        validation: {
            name: 'docLifecycleConfiguration.validation.name',
            group: 'docLifecycleConfiguration.validation.group',
            phases: 'docLifecycleConfiguration.validation.phases',
            duplicateName: 'docLifecycleConfiguration.validation.duplicateName'
        }
    },
    ruleUpload: {
        createRuleTitle: 'ruleUpload.createRuleTitle',
        editRuleTitle: 'ruleUpload.editRuleTitle',
        title: 'ruleUpload.title',
        deletePrompt: 'ruleUpload.deletePrompt',
        deleteRule: 'ruleUpload.deleteRule',
        createRule: 'ruleUpload.createRule',
        reloadRules: 'ruleUpload.reloadRules',
        fields: {
            name: 'ruleUpload.fields.name',
            group: 'ruleUpload.fields.group',
            config: 'ruleUpload.fields.config',
            base: 'ruleUpload.fields.base',
            additional: 'ruleUpload.fields.additional',
            active: 'ruleUpload.fields.active',
            baseSample: 'ruleUpload.fields.baseSample',
            additionalSample: 'ruleUpload.fields.additionalSample'
        },
        validation: {
            name: 'ruleUpload.validation.name',
            group: 'ruleUpload.validation.group',
            config: 'ruleUpload.validation.config',
            base: 'ruleUpload.validation.base',
            additional: 'ruleUpload.validation.additional',
            duplicateName: 'ruleUpload.validation.duplicateName'
        }
    },
    notifications: {
        title: 'notifications.title',
        fields: {
            createdAt: 'notifications.fields.createdAt',
            subscriptionId: 'notifications.fields.subscriptionId',
            channel: 'notifications.fields.channel',
            description: 'notifications.fields.description',
            priority: 'notifications.fields.priority',
            severity: 'notifications.fields.severity',
            title: 'notifications.fields.title',
            aggregation: 'notifications.fields.aggregation',
            type: 'notifications.fields.type',
            alertName: 'notifications.fields.alertName',
            documentCount: 'notifications.fields.documentCount',
            emailSent: 'notifications.fields.emailSent',
            filterName: 'notifications.fields.filterName',
            today: () => {
                return {
                    key: 'notifications.fields.today',
                    paramsMap: ['finalTime']
                };
            },
            yesterday: () => {
                return {
                    key: 'notifications.fields.yesterday',
                    paramsMap: ['finalTime']
                };
            }
        },
        noResultsFound: 'notifications.noResultsFound',
        notificationInfo: 'notifications.notificationInfo',
        notificationDetails: 'notifications.notificationDetails',
        notificationCentreError: 'notifications.notificationCentreError',
        notificationCenterTitle: 'notifications.notificationCenterTitle',
        seeAllNotif: 'notifications.seeAllNotif',
        markAllAsRead: 'notifications.markAllAsRead',
        newNotif: 'notifications.newNotif',
        noNotif: 'notifications.noNotif',
        inboundDocument: 'notifications.inboundDocument',
        outboundDocument: 'notifications.outboundDocument',
        noUserError: 'notifications.noUserError',
        readNotification: 'notifications.readNotification',
        markAsRead: 'notifications.markAsRead'
    },
    auth: {
        signin: 'auth.signin',
        orSignin: 'auth.orSignin',
        signup: 'auth.signup',
        orSignup: 'auth.orSignup',
        signout: 'auth.signout',
        lostPassword: 'auth.lostPassword'
    },

    mftConfigs: {
        fields: {
            name: 'mftConfigs.fields.name',
            agentSyncInterval: 'mftConfigs.fields.agentSyncInterval',
            maxFilesInBatch: 'mftConfigs.fields.maxFilesInBatch',
            created: 'mftConfigs.fields.created',
            configurationName: 'mftConfigs.fields.configurationName',
            edgeFolderLocation: 'mftConfigs.fields.edgeFolderLocation',
            inboundFolderLocation: 'mftConfigs.fields.inboundFolderLocation',
            outboundFolderLocation: 'mftConfigs.fields.outboundFolderLocation',
            filePattern: 'mftConfigs.fields.filePattern',
            partnerGroup: 'mftConfigs.fields.partnerGroup',
            partnerID: 'mftConfigs.fields.partnerID',
            groupName: 'mftConfigs.fields.groupName',
            maxBatchSize: 'mftConfigs.fields.maxBatchSize',
            userName: 'mftConfigs.fields.userName',
            mftConfigSuccessMsg: () => {
                return {
                    key: 'mftConfigs.fields.mftConfigSuccessMsg',
                    paramsMap: ['mftConfigName']
                };
            }
        },
        validations: {
            configurationNameRequired: 'mftConfigs.validations.configurationNameRequired',
            groupRequired: 'mftConfigs.validations.groupRequired',
            partnerGroupNameRequired: 'mftConfigs.validations.partnerGroupNameRequired',
            partnerIdRequired: 'mftConfigs.validations.partnerIdRequired',
            hoursRequired: 'mftConfigs.validations.hoursRequired',
            minutesRequired: 'mftConfigs.validations.minutesRequired',
            maxBatchSizeRequired: 'mftConfigs.validations.maxBatchSizeRequired',
            edgeFolderRequired: 'mftConfigs.validations.edgeFolderRequired',
            inboundFolderRequired: 'mftConfigs.validations.inboundFolderRequired',
            outboundFolderRequired: 'mftConfigs.validations.outboundFolderRequired',
            filePatternRequired: 'mftConfigs.validations.filePatternRequired',
            userNameRequired: 'mftConfigs.validations.userNameRequired',
            agentSyncIntervalRequired: 'mftConfigs.validations.agentSyncIntervalRequired',
            uniqueMFTConfigName: 'mftConfigs.validations.uniqueMFTConfigName',
            uniqueMFTConfigNameForUser: () => {
                return {
                    key: 'mftConfigs.validations.uniqueMFTConfigNameForUser',
                    paramsMap: ['mftConfigName']
                };
            },
            maxBatchSizeValidationMsg: 'mftConfigs.validations.maxBatchSizeValidationMsg',
            hoursExceedError: 'mftConfigs.validations.hoursExceedError',
            minutesExceedError: 'mftConfigs.validations.minutesExceedError'
        },
        title: 'mftConfigs.title',
        addMftConfig: 'mftConfigs.addMftConfig',
        sidebarTitle: 'mftConfigs.sidebarTitle',
        editMftConfigForm: 'mftConfigs.editMftConfigForm',
        deletePrompt: 'mftConfigs.deletePrompt',
        downloadMftAgent: 'mftConfigs.downloadMftAgent'
    },

    filters: {
        contains: 'filters.contains',
        equals: 'filters.equals',
        deleteFilter: 'filters.deleteFilter',
        addFilters: 'filters.addFilters',
        addFiltersMsg: 'filters.addFiltersMsg',
        clearFilters: 'filters.clearFilters',
        editFilters: 'filters.editFilters',
        notEquals: 'filters.notEquals'
    },
    help: 'help',
    support: 'support',
    buttons: {
        switch: 'buttons.switch',
        ok: 'buttons.ok',
        cancel: 'buttons.cancel',
        continue: 'buttons.continue',
        done: 'buttons.done',
        save: 'buttons.save',
        saveAsDraft: 'buttons.saveAsDraft',
        close: 'buttons.close',
        copy: 'buttons.copy',
        delete: 'buttons.delete',
        deleteChild: 'buttons.deleteChild',
        deleteDraft: 'buttons.deleteDraft',
        resetDraft: 'buttons.resetDraft',
        pickPack: 'buttons.pickPack',
        print: 'buttons.print',
        change: 'buttons.change',
        reject: 'buttons.reject',
        accept: 'buttons.accept',
        clearFilter: 'buttons.clearFilter',
        columns: 'buttons.columns',
        filters: 'buttons.filters',
        density: 'buttons.density',
        back: 'buttons.back',
        addAnotherPair: 'buttons.addAnotherPair',
        browsePresets: 'buttons.browsePresets',
        export: 'buttons.export',
        import: 'buttons.import',
        selectAll: 'buttons.selectAll',
        selectNone: 'buttons.selectNone',
        asInTable: 'buttons.asInTable',
        refresh: 'buttons.refresh',
        download: 'buttons.download',
        edit: 'buttons.edit',
        editAliases: 'buttons.editAliases',
        removeAlias: 'buttons.removeAlias',
        run: 'buttons.run',
        apply: 'buttons.apply',
        select: 'buttons.select',
        next: 'buttons.next',
        send: 'buttons.send',
        attach: 'buttons.attach',
        discard: 'buttons.discard',
        applyFilters: 'buttons.applyFilters',
        undo: 'buttons.undo',
        update: 'buttons.update',
        applyChanges: 'buttons.applyChanges',
        updateAlias: 'buttons.updateAlias',
        upload: 'buttons.upload',
        remove: 'buttons.remove',
        reset: 'buttons.reset',
        deleteButton: 'buttons.deleteButton',
        cancelButton: 'buttons.cancelButton',
        duplicateButton: 'buttons.duplicateButton',
        setToInactiveSwitch: 'buttons.setToInactiveSwitch',
        setToActiveSwitch: 'buttons.setToActiveSwitch',
        exportCSV: 'buttons.exportCSV',
        importCSV: 'buttons.importCSV'
    },
    links: {
        edit: 'links.edit'
    },
    copy: 'copy',
    acknowledge: 'acknowledge',
    useAskEdx: 'useAskEdx',
    askEdxAgreementMsg: 'askEdxAgreementMsg',
    enableAskEdx: 'enableAskEdx',
    agreeBtn: 'agreeBtn',
    iAgreeMessage: 'iAgreeMessage',
    warnings: {
        tz: 'warnings.tz',
        getPreferenceTzWarning: () => {
            return {
                key: 'warnings.getPreferenceTzWarning',
                paramsMap: ['offset']
            };
        }
    },
    draft: {
        popupTitle: 'draft.popupTitle',
        popupMessage: () => {
            return {
                key: 'draft.popupMessage',
                paramsMap: ['author']
            };
        },
        formName: () => {
            return {
                key: 'draft.formName',
                paramsMap: ['target']
            };
        }
    },
    languagesSupported: {
        enUS: 'languagesSupported.enUS',
        // esUS: 'languagesSupported.esUS',
        deDE: 'languagesSupported.deDE'
        // frCA: 'languagesSupported.frCA'
    },
    passwordExpired: {
        msg: 'passwordExpired.msg',
        passwordExpireyToday: 'passwordExpired.passwordExpireyToday',
        passwordExpiryInDays: () => {
            return {
                key: 'passwordExpired.passwordExpiryInDays',
                paramsMap: ['daysDiff']
            };
        },
        dialogTile: 'passwordExpired.dialogTile'
    },
    routes: {
        admin: 'routes.admin',
        allDocuments: 'routes.allDocuments',
        audits: 'routes.audits',
        billing: 'routes.billing',
        customerSubscriptionManagement: 'routes.customerSubscriptionManagement',
        csfMappings: 'routes.csfMappings',
        home: 'routes.home',
        documents: 'routes.documents',
        dashboard: 'routes.dashboard',
        docViewer: 'routes.docViewer',
        ecommerceStore: 'routes.ecommerceStore',
        apiIntegration: 'routes.apiIntegration',
        presets: 'routes.presets',
        envelopes: 'routes.envelopes',
        formMappings: 'routes.formMappings',
        shippingLabels: 'routes.shippingLabels',
        forms: 'routes.forms',
        utilities: 'routes.utilities',
        groups: 'routes.groups',
        inbox: 'routes.inbox',
        manageAlerts: 'routes.manageAlerts',
        users: 'routes.users',
        roles: 'routes.roles',
        activities: 'routes.activities',
        activityDocs: 'routes.activityDocs',
        documentSets: 'routes.documentSets',
        documentSet: 'routes.documentSet',
        newOutboundForm: 'routes.newOutboundForm',
        notifications: 'routes.notifications',
        sentDocuments: 'routes.sentDocuments',
        partnerGroups: 'routes.partnerGroups',
        clearingPartners: 'routes.clearingPartners',
        partners: 'routes.partners',
        pickAndPack: 'routes.pickAndPack',
        docLifecycle: 'routes.docLifecycle',
        docLifecycleConfiguration: 'routes.docLifecycleConfiguration',
        docLifecycleRules: 'routes.docLifecycleRules',
        communicationError: 'routes.communicationError',
        edgeMFTConfiguration: 'routes.edgeMFTConfiguration',
        catalogueManagement: 'routes.catalogueManagement',
        orderHub: 'routes.orderHub',
        pageDynamicContent: 'routes.pageDynamicContent'
    },
    common: {
        addChild: 'common.addChild',
        addItem: 'common.addItem',
        from: 'common.from',
        to: 'common.to',
        currentMonth: 'common.currentMonth',
        children: 'common.children',
        enterText: 'common.enterText',
        forAllTime: 'common.forAllTime',
        nothingToShow: 'common.nothingToShow',
        templateError: 'common.templateError',
        ruleError: 'common.ruleError',
        title: 'common.title',
        addValue: 'common.addValue',
        name: 'common.name',
        search: 'common.search',
        restore: 'common.restore',
        showAll: 'common.showAll',
        showNone: 'common.showNone',
        tagsList: 'common.tagsList',
        status: 'common.status',
        restart: 'common.restart',
        noMatch: 'common.noMatch',
        aggregateBy: 'common.aggregateBy',
        state: 'common.state',
        readStatus: 'common.readStatus',
        textCopied: 'common.textCopied',
        active: 'common.active',
        chooseColor: 'common.chooseColor',
        select3Ellipsis: 'common.select3Ellipsis',
        group: 'common.group',
        yes: 'common.yes',
        no: 'common.no',
        greeting: () => {
            return {
                key: 'common.greeting',
                paramsMap: ['fullName']
            };
        },
        welcome: () => {
            return {
                key: 'common.welcome',
                paramsMap: ['fullName']
            };
        },
        welcomeMsg: 'common.welcomeMsg',
        typeToSearch: 'common.typeToSearch'
    },
    customers: {
        title: 'customers.title',
        table: {
            columns: {
                status: 'customers.table.columns.status',
                name: 'customers.table.columns.name',
                distinguishName: 'customers.table.columns.distinguishName',
                product: 'customers.table.columns.product',
                plan: 'customers.table.columns.plan',
                actions: 'customers.table.columns.actions',
                tariff: 'customers.table.columns.tariff',
                current: 'customers.table.columns.current',
                nextBillDate: 'customers.table.columns.nextBillDate',
                billingRecords: 'customers.table.columns.billingRecords',
                dynamics: 'customers.table.columns.dynamics',
                customer: 'customers.table.columns.customer',
                bRunType: 'customers.table.columns.bRunType',
                ID: 'customers.table.columns.ID',
                products: 'customers.table.columns.products',
                currency: 'customers.table.columns.currency'
            },
            tooltip: {
                sort: 'customers.table.tooltip.sort',
                history: 'customers.table.tooltip.history',
                bRun: 'customers.table.tooltip.bRun',
                settings: 'customers.table.tooltip.settings'
            }
        }
    },
    mainMenu: {
        home: 'mainMenu.home',
        customers: 'mainMenu.customers',
        products: 'mainMenu.products',
        brh: 'mainMenu.brh',
        billingRecords: 'mainMenu.billingRecords',
        tariffs: 'mainMenu.tariffs',
        schedules: 'mainMenu.schedules',
        reports: 'mainMenu.reports'
    },
    impersonation: {
        impersonate: 'impersonation.impersonate',
        stop: 'impersonation.stop',
        textGroup: () => {
            return {
                key: 'impersonation.textGroup',
                paramsMap: ['name']
            };
        },
        textUser: () => {
            return {
                key: 'impersonation.textUser',
                paramsMap: ['name']
            };
        }
    },
    communicationError: {
        acknowledged: 'communicationError.acknowledged',
        acknowledge: 'communicationError.acknowledge',
        acknowledgements: 'communicationError.acknowledgements',
        acknowledgedBy: 'communicationError.acknowledgedBy',
        acknowledgeReprocess: 'communicationError.acknowledgeReprocess',
        messageId: 'communicationError.messageId',
        unacknowledge: 'communicationError.unacknowledge',
        unacknowledgeBy: 'communicationError.unacknowledgeBy'
    },
    envelopes: {
        title: 'envelopes.title',
        fields: {
            editUrl: 'envelopes.fields.editUrl'
        },
        cdxCluter: 'envelopes.cdxCluter',
        notConfigured: 'envelopes.notConfigured',
        unlinkEnvelope: 'envelopes.unlinkEnvelope',
        counterName: 'envelopes.counterName',
        deleteCounter: 'envelopes.deleteCounter',
        counterOptions: 'envelopes.counterOptions',
        createCounter: 'envelopes.createCounter',
        attachedEnvelopes: 'envelopes.attachedEnvelopes',
        currentValue: 'envelopes.currentValue',
        cDXClusterEnvelopes: 'envelopes.cDXClusterEnvelopes',
        counters: 'envelopes.counters',
        actions: {
            unlink: 'envelopes.actions.unlink',
            cancel: 'envelopes.actions.cancel',
            save: 'envelopes.actions.save',
            create: 'envelopes.actions.create',
            close: 'envelopes.actions.close',
            discard: 'envelopes.actions.discard'
        },
        form: {
            labels: {
                startValue: 'envelopes.form.labels.startValue',
                sender: 'envelopes.form.labels.sender',
                receiver: 'envelopes.form.labels.receiver',
                document: 'envelopes.form.labels.document',
                fileName: 'envelopes.form.labels.fileName'
            }
        },
        table: {
            columns: {
                testFlag: 'envelopes.table.columns.testFlag',
                document: 'envelopes.table.columns.document',
                eDIFormatType: 'envelopes.table.columns.eDIFormatType',
                messageName: 'envelopes.table.columns.messageName',
                elementSeparator: 'envelopes.table.columns.elementSeparator',
                segmentSeparator: 'envelopes.table.columns.segmentSeparator',
                fieldSeparator: 'envelopes.table.columns.fieldSeparator',
                repetitionCharacter: 'envelopes.table.columns.repetitionCharacter',
                testIndicator: 'envelopes.table.columns.testIndicator',
                interchangeControlVersionNumber:
                    'envelopes.table.columns.interchangeControlVersionNumber',
                interchangeAuthorizationInformationQualifier:
                    'envelopes.table.columns.interchangeAuthorizationInformationQualifier',
                acknowledgementRequest: 'envelopes.table.columns.acknowledgementRequest',
                extraWhitespace: 'envelopes.table.columns.extraWhitespace',
                versionCode: 'envelopes.table.columns.versionCode'
            }
        },
        errorDialogTitle: 'envelopes.errorDialogTitle',
        saveDialogMessage: () => {
            return {
                key: 'envelopes.saveDialogMessage',
                paramsMap: ['filename']
            };
        }
    },

    export: {
        add: 'export.add',
        title: 'export.title',
        exportAs: 'export.exportAs',
        including: 'export.including',
        columns: 'export.columns',
        visibleColumns: 'export.visibleColumns',
        downloadZip: 'export.downloadZip',
        fields: {
            downloadSource: 'export.fields.downloadSource',
            downloadStorage: 'export.fields.downloadStorage',
            downloadTarget: 'export.fields.downloadTarget',
            downloadForm: 'export.fields.downloadForm',
            exportSelection: 'export.fields.exportSelection',
            exportType: 'export.fields.exportType',
            documentCount: 'export.fields.documentCount',
            downloadLimit: 'export.fields.downloadLimit',
            form: 'export.fields.form',
            information: 'export.fields.information',
            inbound: 'export.fields.inbound',
            storage: 'export.fields.storage',
            outbound: 'export.fields.outbound',
            reset: 'export.fields.reset',
            limit: 'export.fields.limit',
            source: 'export.fields.source',
            target: 'export.fields.target'
        },
        formats: {
            JSON: 'export.formats.JSON',
            XML: 'export.formats.XML',
            CSV: 'export.formats.CSV'
        },
        menu: {
            filterText: 'export.menu.filterText',
            markAllRead: 'export.menu.markAllRead'
        },
        saveAs: 'export.saveAs',
        warning: 'export.warning'
    },
    docAcknowledge: {
        title: 'docAcknowledge.title',
        submit: 'docAcknowledge.submit',
        comment: 'docAcknowledge.comment',
        ackStatus: 'docAcknowledge.ackStatus'
    },
    docUnacknowledge: {
        title: 'docUnacknowledge.title',
        docCountUnAcknowledged: () => {
            return {
                key: 'docUnacknowledge.docCountUnAcknowledged',
                paramsMap: ['x', 'y']
            };
        },
        unAckDocPopupTitle: 'docUnacknowledge.unAckDocPopupTitle',
        unAckErrorMsg: 'docUnacknowledge.unAckErrorMsg',
        ackFailureMsg: 'docUnacknowledge.ackFailureMsg',
        reprocessButton: 'docUnacknowledge.reprocessButton'
    },
    generateAcknowledgement: {
        title: 'generateAcknowledgement.title',
        submit: 'generateAcknowledgement.submit',
        erpOption: 'generateAcknowledgement.erpOption',
        selectedDocumentsInfo: () => {
            return {
                key: 'generateAcknowledgement.selectedDocumentsInfo',
                paramsMap: ['eligibleDocCount', 'selectedDocCount']
            };
        }
    },
    facetedFilters: {
        table: {
            columns: {
                sender: 'facetedFilters.table.columns.sender',
                receiver: 'facetedFilters.table.columns.receiver',
                dateTime: 'facetedFilters.table.columns.dateTime',
                document: 'facetedFilters.table.columns.document',
                stage: 'facetedFilters.table.columns.stage',
                state: 'facetedFilters.table.columns.state',
                type: 'facetedFilters.table.columns.type',
                direction: 'facetedFilters.table.columns.direction'
            }
        },
        results: {
            filtered: 'facetedFilters.results.filtered',
            total: 'facetedFilters.results.total'
        }
    },
    inlineDisplayName: {
        title: 'inlineDisplayName.title',
        displayName: 'inlineDisplayName.displayName',
        parentDisplayName: 'inlineDisplayName.parentDisplayName',
        partnerName: 'inlineDisplayName.partnerName',
        id: 'inlineDisplayName.id'
    },
    pagination: {
        currentPage: () => {
            return {
                key: 'pagination.currentPage',
                paramsMap: ['totalPage']
            };
        },
        exactPage: 'pagination.exactPage',
        first: 'pagination.first',
        previous: 'pagination.previous',
        last: 'pagination.last',
        itemsPerPage: 'pagination.itemsPerPage',
        total: 'pagination.total',
        totalWithCount: () => {
            return {
                key: 'pagination.totalWithCount',
                paramsMap: ['count']
            };
        },
        filteredOf: () => {
            return {
                key: 'pagination.filteredOf',
                paramsMap: ['filtered', 'total']
            };
        },
        inputError: 'pagination.inputError'
    },
    counterTable: {
        level: 'counterTable.level',
        name: 'counterTable.name',
        nameWithSelected: () => {
            return {
                key: 'counterTable.nameWithSelected',
                paramsMap: ['selected']
            };
        },
        linkage: 'counterTable.linkage',
        currentValue: 'counterTable.currentValue',
        value: 'counterTable.value',
        interchange: 'counterTable.interchange',
        group: 'counterTable.group',
        message: 'counterTable.message',
        unlinkCounter: 'counterTable.unlinkCounter',
        unlink: 'counterTable.unlink',
        cancel: 'counterTable.cancel',
        attachCounter: 'counterTable.attachCounter',
        chooseCounter: 'counterTable.chooseCounter',
        counters: 'counterTable.counters',
        identifierLevel: 'counterTable.identifierLevel',
        senderID: 'counterTable.senderID',
        senderIDQual: 'counterTable.senderIDQual',
        receiverID: 'counterTable.receiverID',
        receiverIDQual: 'counterTable.receiverIDQual',
        groupLevelParameter: 'counterTable.groupLevelParameter',
        functionalIDCode: 'counterTable.functionalIDCode',
        responsibleAgencyCode: 'counterTable.responsibleAgencyCode',
        versionCode: 'counterTable.versionCode',
        identifiers: 'counterTable.identifiers'
    },
    fts: {
        menu: {
            all: 'fts.menu.all',
            storage: 'fts.menu.storage',
            inbound: 'fts.menu.inbound',
            outbound: 'fts.menu.outbound'
        },
        radioGroup: {
            partial: 'fts.radioGroup.partial',
            exact: 'fts.radioGroup.exact',
            regEx: 'fts.radioGroup.regEx',
            partialTitle: 'fts.radioGroup.partialTitle',
            exactTitle: 'fts.radioGroup.exactTitle',
            noMatch: 'fts.radioGroup.noMatch',
            noMatchTitle: 'fts.radioGroup.noMatchTitle'
        },
        exactMatch: 'fts.exactMatch',
        searchTermError: 'fts.searchTermError',
        minLengthBracketError: 'fts.minLengthBracketError',
        invalidFormatError: 'fts.invalidFormatError',
        fileSizeLimitMessage: 'fts.fileSizeLimitMessage',
        ftsFormatMessage: 'fts.ftsFormatMessage',
        invalidLengthError: 'fts.invalidLengthError'
    },
    template: {
        cloneTemplate: 'template.cloneTemplate',
        deleteTemplate: 'template.deleteTemplate',
        startRule: 'template.startRule',
        startRuleGroup: 'template.startRuleGroup',
        templateSource: 'template.templateSource',
        triggers: 'template.triggers'
    },
    location: {
        ie: 'location.ie',
        us: 'location.us'
    },
    askEdx: {
        title: 'askEdx.title',
        userTyping: { 1: 'askEdx.userTyping.1' },
        userTalking: { 1: 'askEdx.userTalking.1' },
        processing: {
            1: 'askEdx.processing.1',
            2: 'askEdx.processing.2',
            3: 'askEdx.processing.3',
            4: 'askEdx.processing.4',
            5: 'askEdx.processing.5',
            6: 'askEdx.processing.6',
            7: 'askEdx.processing.7',
            8: 'askEdx.processing.8',
            9: 'askEdx.processing.9',
            10: 'askEdx.processing.10'
        },
        result: {
            1: 'askEdx.result.1',
            2: 'askEdx.result.2',
            3: 'askEdx.result.3',
            4: 'askEdx.result.4',
            5: 'askEdx.result.5'
        },
        resultResponse: {
            1: 'askEdx.resultResponse.1',
            2: 'askEdx.resultResponse.2',
            3: 'askEdx.resultResponse.3',
            4: 'askEdx.resultResponse.4',
            5: 'askEdx.resultResponse.5',
            6: 'askEdx.resultResponse.6',
            7: 'askEdx.resultResponse.7',
            8: 'askEdx.resultResponse.8'
        },
        feedback: {
            1: 'askEdx.feedback.1',
            2: 'askEdx.feedback.2',
            3: 'askEdx.feedback.3',
            4: 'askEdx.feedback.4',
            5: 'askEdx.feedback.5',
            6: 'askEdx.feedback.6',
            7: 'askEdx.feedback.7',
            8: 'askEdx.feedback.8'
        },
        feedbackResponse: {
            1: 'askEdx.feedbackResponse.1',
            2: 'askEdx.feedbackResponse.2',
            3: 'askEdx.feedbackResponse.3',
            4: 'askEdx.feedbackResponse.4',
            5: 'askEdx.feedbackResponse.5',
            6: 'askEdx.feedbackResponse.6'
        },
        error: {
            1: 'askEdx.error.1',
            2: 'askEdx.error.2',
            3: 'askEdx.error.3',
            4: 'askEdx.error.4',
            5: 'askEdx.error.5',
            6: 'askEdx.error.6'
        },
        searchTips: {
            1: 'askEdx.searchTips.1',
            2: 'askEdx.searchTips.2',
            3: 'askEdx.searchTips.3',
            4: 'askEdx.searchTips.4',
            5: 'askEdx.searchTips.5',
            6: 'askEdx.searchTips.6',
            7: 'askEdx.searchTips.7'
        },
        tryAgain: 'askEdx.tryAgain',
        typeHere: 'askEdx.typeHere',
        listening: 'askEdx.listening',
        welcomeTitle: 'askEdx.welcomeTitle',
        subtitleMessage: 'askEdx.subtitleMessage',
        permissionMessage: 'askEdx.permissionMessage',
        infoMessage: 'askEdx.infoMessage',
        dataTableConst: 'askEdx.dataTableConst',
        checkQueryResults: 'askEdx.checkQueryResults',
        hereLink: 'askEdx.hereLink',
        feedbackTitle: 'askEdx.feedbackTitle',
        feedbackSubtitle: 'askEdx.feedbackSubtitle',
        feedbackThankYou: 'askEdx.feedbackThankYou',
        feedbackOptions: {
            inaccurateInfo: 'askEdx.feedbackOptions.inaccurateInfo',
            didntFollowInstructions: 'askEdx.feedbackOptions.didntFollowInstructions',
            fieldsMismatch: 'askEdx.feedbackOptions.fieldsMismatch',
            refusedToAnswer: 'askEdx.feedbackOptions.refusedToAnswer',
            biasedResponse: 'askEdx.feedbackOptions.biasedResponse',
            problematicContent: 'askEdx.feedbackOptions.problematicContent',
            poorStyle: 'askEdx.feedbackOptions.poorStyle'
        },
        notSupportedContent: 'askEdx.notSupportedContent',
        notSupportedContent2: 'askEdx.notSupportedContent2',
        prompt1: 'askEdx.prompt1',
        prompt2: 'askEdx.prompt2',
        prompt3: 'askEdx.prompt3',
        prompt4: 'askEdx.prompt4',
        prompt5: 'askEdx.prompt5',
        prompt4Resp: 'askEdx.prompt4Resp',
        prompt5Resp: 'askEdx.prompt5Resp',
        capabilitiesTitle: 'askEdx.capabilitiesTitle',
        folderTooltipAll: 'askEdx.folderTooltipAll',
        folderTooltipInbox: 'askEdx.folderTooltipInbox',
        folderTooltipSend: 'askEdx.folderTooltipSend',
        viewTooltipTable: 'askEdx.viewTooltipTable',
        viewTooltipGraph: 'askEdx.viewTooltipGraph',
        termsToolTip01: 'askEdx.termsToolTip01',
        termsToolTip02: 'askEdx.termsToolTip02',
        termsToolTip03: 'askEdx.termsToolTip03',
        initialLoadingMsg: 'askEdx.initialLoadingMsg',
        inputPlaceholder: 'askEdx.inputPlaceholder',
        askEdxDisclaimer: 'askEdx.askEdxDisclaimer',
        termsMsg1_01: 'askEdx.termsMsg1_01',
        termsMsg1_02: 'askEdx.termsMsg1_02',
        termsMsg1_03: 'askEdx.termsMsg1_03',
        termsMsg2_01: 'askEdx.termsMsg2_01',
        termsMsg2_02: 'askEdx.termsMsg2_02',
        termsMsg2_03: 'askEdx.termsMsg2_03',
        noData: 'askEdx.noData',
        capabilities: {
            1: 'askEdx.capabilities.1',
            2: 'askEdx.capabilities.2',
            3: 'askEdx.capabilities.3'
        },
        tips: {
            1: 'askEdx.tips.1',
            2: 'askEdx.tips.2',
            3: 'askEdx.tips.3',
            4: 'askEdx.tips.4',
            5: 'askEdx.tips.5'
        },
        loadingMessages: {
            1: 'askEdx.loadingMessages.1',
            2: 'askEdx.loadingMessages.2',
            3: 'askEdx.loadingMessages.3',
            4: 'askEdx.loadingMessages.4',
            5: 'askEdx.loadingMessages.5'
        },
        timeoutError: 'askEdx.timeoutError',
        generalError: 'askEdx.generalError'
    },
    errorBoundary: {
        title: 'errorBoundary.title',
        message: 'errorBoundary.message',
        goHomeButton: 'errorBoundary.goHomeButton',
        errorDetailsTitle: 'errorBoundary.errorDetailsTitle',
        errorLabel: 'errorBoundary.errorLabel',
        componentStackLabel: 'errorBoundary.componentStackLabel'
    },
    subscriptionManagement: {
        subscriptionPortal: 'subscriptionManagement.subscriptionPortal',
        supportDashboard: 'subscriptionManagement.supportDashboard',
        actionFallback: actionKey => {
            return {
                key: 'subscriptionManagement.actionFallback',
                paramsMap: ['actionKey']
            };
        },
        tabs: {
            overview: 'subscriptionManagement.tabs.overview',
            usageMetrics: 'subscriptionManagement.tabs.usageMetrics',
            billing: 'subscriptionManagement.tabs.billing',
            configureOverages: 'subscriptionManagement.tabs.configureOverages'
        },
        status: {
            active: 'subscriptionManagement.status.active',
            expiringSoon: 'subscriptionManagement.status.expiringSoon',
            suspended: 'subscriptionManagement.status.suspended',
            expired: 'subscriptionManagement.status.expired'
        },
        header: {
            customerName: 'subscriptionManagement.header.customerName',
            contractStatus: 'subscriptionManagement.header.contractStatus',
            daysRemaining: 'subscriptionManagement.header.daysRemaining',
            agreementType: 'subscriptionManagement.header.agreementType'
        },
        contract: {
            title: 'subscriptionManagement.contract.title',
            customerCountry: 'subscriptionManagement.contract.customerCountry',
            contractStartDate: 'subscriptionManagement.contract.contractStartDate',
            contractEndDate: 'subscriptionManagement.contract.contractEndDate',
            salesforceId: 'subscriptionManagement.contract.salesforceId',
            billingCycle: 'subscriptionManagement.contract.billingCycle',
            service: 'subscriptionManagement.contract.service',
            orderNumber: 'subscriptionManagement.contract.orderNumber',
            termInMonths: 'subscriptionManagement.contract.termInMonths'
        },
        features: {
            title: 'subscriptionManagement.features.title',
            countLabel: count => {
                return {
                    key: 'subscriptionManagement.features.countLabel',
                    paramsMap: ['count']
                };
            },
            exploreMore: 'subscriptionManagement.features.exploreMore',
            noFeatures: 'subscriptionManagement.features.noFeatures',
            modalTitle: 'subscriptionManagement.features.modalTitle',
            modalSubtitle: 'subscriptionManagement.features.modalSubtitle',
            addOnsLabel: count => {
                return {
                    key: 'subscriptionManagement.features.addOnsLabel',
                    paramsMap: ['count']
                };
            },
            learnMore: 'subscriptionManagement.features.learnMore',
            close: 'subscriptionManagement.features.close',
            requestUpgrade: 'subscriptionManagement.features.requestUpgrade'
        },
        quickActions: {
            supportActions: 'subscriptionManagement.quickActions.supportActions',
            quickActions: 'subscriptionManagement.quickActions.quickActions',
            contactSupport: 'subscriptionManagement.quickActions.contactSupport',
            requestUpgrade: 'subscriptionManagement.quickActions.requestUpgrade',
            downloadInvoice: 'subscriptionManagement.quickActions.downloadInvoice',
            extendContract: 'subscriptionManagement.quickActions.extendContract',
            adjustUsage: 'subscriptionManagement.quickActions.adjustUsage',
            sendNotice: 'subscriptionManagement.quickActions.sendNotice',
            escalate: 'subscriptionManagement.quickActions.escalate',
            addMember: 'subscriptionManagement.quickActions.addMember',
            suspend: 'subscriptionManagement.quickActions.suspend',
            reactivate: 'subscriptionManagement.quickActions.reactivate',
            reinstate: 'subscriptionManagement.quickActions.reinstate'
        },
        actionMessages: {
            requestUpgrade: 'subscriptionManagement.actionMessages.requestUpgrade',
            downloadInvoice: 'subscriptionManagement.actionMessages.downloadInvoice',
            contactSupport: 'subscriptionManagement.actionMessages.contactSupport',
            extendContract: 'subscriptionManagement.actionMessages.extendContract',
            adjustUsage: 'subscriptionManagement.actionMessages.adjustUsage',
            sendNotice: 'subscriptionManagement.actionMessages.sendNotice',
            escalate: 'subscriptionManagement.actionMessages.escalate',
            addMember: 'subscriptionManagement.actionMessages.addMember',
            suspend: 'subscriptionManagement.actionMessages.suspend',
            reactivate: 'subscriptionManagement.actionMessages.reactivate',
            reinstate: 'subscriptionManagement.actionMessages.reinstate',
            notificationSaved: 'subscriptionManagement.actionMessages.notificationSaved',
            overageSaved: 'subscriptionManagement.actionMessages.overageSaved',
            overageSettingsSaved: 'subscriptionManagement.actionMessages.overageSettingsSaved',
            emailSendFailed: 'subscriptionManagement.actionMessages.emailSendFailed',
            upgradeRequestFailed: 'subscriptionManagement.actionMessages.upgradeRequestFailed'
        },
        metrics: {
            messageCount: 'subscriptionManagement.metrics.messageCount',
            kiloCharacter: 'subscriptionManagement.metrics.kiloCharacter',
            peakVolumeHour: 'subscriptionManagement.metrics.peakVolumeHour',
            avgFileSize: 'subscriptionManagement.metrics.avgFileSize',
            unitCount: 'subscriptionManagement.metrics.unitCount',
            unitKb: 'subscriptionManagement.metrics.unitKb',
            unitMb: 'subscriptionManagement.metrics.unitMb'
        },
        summary: {
            overageCost: 'subscriptionManagement.summary.overageCost',
            noOverages: 'subscriptionManagement.summary.noOverages',
            currentOverages: 'subscriptionManagement.summary.currentOverages',
            dataRetention: 'subscriptionManagement.summary.dataRetention',
            defaultRetention: 'subscriptionManagement.summary.defaultRetention',
            defaultRetentionSize: 'subscriptionManagement.summary.defaultRetentionSize',
            supportTickets: 'subscriptionManagement.summary.supportTickets',
            openResolved: (open, resolved) => {
                return {
                    key: 'subscriptionManagement.summary.openResolved',
                    paramsMap: ['open', 'resolved']
                };
            }
        },
        featureMetrics: {
            title: 'subscriptionManagement.featureMetrics.title',
            x12Support: 'subscriptionManagement.featureMetrics.x12Support',
            edifactSupport: 'subscriptionManagement.featureMetrics.edifactSupport',
            xmlSupport: 'subscriptionManagement.featureMetrics.xmlSupport',
            apiAccess: 'subscriptionManagement.featureMetrics.apiAccess',
            advancedAnalytics: 'subscriptionManagement.featureMetrics.advancedAnalytics',
            partnerManagement: 'subscriptionManagement.featureMetrics.partnerManagement',
            documentsProcessed: 'subscriptionManagement.featureMetrics.documentsProcessed',
            successRate: 'subscriptionManagement.featureMetrics.successRate',
            dailyLimit: 'subscriptionManagement.featureMetrics.dailyLimit',
            todaysUsage: 'subscriptionManagement.featureMetrics.todaysUsage',
            reportsGenerated: 'subscriptionManagement.featureMetrics.reportsGenerated',
            lastGenerated: 'subscriptionManagement.featureMetrics.lastGenerated',
            activePartners: 'subscriptionManagement.featureMetrics.activePartners',
            totalMapped: 'subscriptionManagement.featureMetrics.totalMapped',
            lastGeneratedValue: 'subscriptionManagement.featureMetrics.lastGeneratedValue'
        },
        metricRow: {
            duration: 'subscriptionManagement.metricRow.duration',
            lastYear: 'subscriptionManagement.metricRow.lastYear',
            lastQuarter: 'subscriptionManagement.metricRow.lastQuarter',
            currentYear: 'subscriptionManagement.metricRow.currentYear',
            month: 'subscriptionManagement.metricRow.month',
            custom: 'subscriptionManagement.metricRow.custom',
            from: 'subscriptionManagement.metricRow.from',
            to: 'subscriptionManagement.metricRow.to',
            cancel: 'subscriptionManagement.metricRow.cancel',
            apply: 'subscriptionManagement.metricRow.apply',
            invalidRange: 'subscriptionManagement.metricRow.invalidRange',
            estimatedUsageTrend: 'subscriptionManagement.metricRow.estimatedUsageTrend',
            estimatesNote: unit => {
                return {
                    key: 'subscriptionManagement.metricRow.estimatesNote',
                    paramsMap: ['unit']
                };
            },
            measured: 'subscriptionManagement.metricRow.measured',
            agreed: 'subscriptionManagement.metricRow.agreed',
            estYtd: 'subscriptionManagement.metricRow.estYtd',
            vsAgreed: 'subscriptionManagement.metricRow.vsAgreed',
            peakAtTooltip: (value, time) => {
                return {
                    key: 'subscriptionManagement.metricRow.peakAtTooltip',
                    paramsMap: ['value', 'time']
                };
            }
        },
        trendChart: {
            title: 'subscriptionManagement.trendChart.title',
            currentYear: 'subscriptionManagement.trendChart.currentYear',
            lastYear: 'subscriptionManagement.trendChart.lastYear',
            lastQuarter: 'subscriptionManagement.trendChart.lastQuarter',
            month: 'subscriptionManagement.trendChart.month',
            agreedThreshold: 'subscriptionManagement.trendChart.agreedThreshold',
            measuredUsage: 'subscriptionManagement.trendChart.measuredUsage'
        },
        supportDashboardTable: {
            noData: 'subscriptionManagement.supportDashboardTable.noData',
            noDataDesc: 'subscriptionManagement.supportDashboardTable.noDataDesc',
            customer: 'subscriptionManagement.supportDashboardTable.customer',
            status: 'subscriptionManagement.supportDashboardTable.status',
            messageCount: 'subscriptionManagement.supportDashboardTable.messageCount',
            kiloCharacter: 'subscriptionManagement.supportDashboardTable.kiloCharacter',
            peakVolumeHour: 'subscriptionManagement.supportDashboardTable.peakVolumeHour',
            avgFileSize: 'subscriptionManagement.supportDashboardTable.avgFileSize',
            overageCost: 'subscriptionManagement.supportDashboardTable.overageCost',
            dateRangeNote: 'subscriptionManagement.supportDashboardTable.dateRangeNote'
        },
        billing: {
            details: 'subscriptionManagement.billing.details',
            billingEmail: 'subscriptionManagement.billing.billingEmail',
            taxId: 'subscriptionManagement.billing.taxId',
            companyName: 'subscriptionManagement.billing.companyName',
            nextBillingDate: 'subscriptionManagement.billing.nextBillingDate',
            billingAddress: 'subscriptionManagement.billing.billingAddress',
            currentPeriod: 'subscriptionManagement.billing.currentPeriod',
            period: 'subscriptionManagement.billing.period',
            amountDue: 'subscriptionManagement.billing.amountDue',
            paymentStatus: 'subscriptionManagement.billing.paymentStatus',
            paidOn: date => {
                return {
                    key: 'subscriptionManagement.billing.paidOn',
                    paramsMap: ['date']
                };
            },
            invoiceHistory: 'subscriptionManagement.billing.invoiceHistory',
            invoice: 'subscriptionManagement.billing.invoice',
            date: 'subscriptionManagement.billing.date',
            amount: 'subscriptionManagement.billing.amount',
            status: 'subscriptionManagement.billing.status',
            actions: 'subscriptionManagement.billing.actions',
            download: 'subscriptionManagement.billing.download',
            transactions: 'subscriptionManagement.billing.transactions',
            transactionsWithCount: count => {
                return {
                    key: 'subscriptionManagement.billing.transactionsWithCount',
                    paramsMap: ['count']
                };
            },
            partnerIdLabel: id => {
                return {
                    key: 'subscriptionManagement.billing.partnerIdLabel',
                    paramsMap: ['id']
                };
            },
            externalNrLabel: id => {
                return {
                    key: 'subscriptionManagement.billing.externalNrLabel',
                    paramsMap: ['id']
                };
            },
            partnerId: 'subscriptionManagement.billing.partnerId',
            externalNrFilterLabel: 'subscriptionManagement.billing.externalNrFilterLabel',
            startDateLabel: 'subscriptionManagement.billing.startDateLabel',
            endDateLabel: 'subscriptionManagement.billing.endDateLabel',
            apply: 'subscriptionManagement.billing.apply',
            reset: 'subscriptionManagement.billing.reset',
            loadTransactionsFailed: 'subscriptionManagement.billing.loadTransactionsFailed',
            noTransactions: 'subscriptionManagement.billing.noTransactions',
            externalNr: 'subscriptionManagement.billing.externalNr',
            partner: 'subscriptionManagement.billing.partner',
            userGroup: 'subscriptionManagement.billing.userGroup',
            direction: 'subscriptionManagement.billing.direction',
            startCol: 'subscriptionManagement.billing.startCol',
            endCol: 'subscriptionManagement.billing.endCol',
            msgCount: 'subscriptionManagement.billing.msgCount',
            kcCount: 'subscriptionManagement.billing.kcCount',
            paymentTerms: 'subscriptionManagement.billing.paymentTerms',
            paymentTerm1: 'subscriptionManagement.billing.paymentTerm1',
            paymentTerm2: 'subscriptionManagement.billing.paymentTerm2',
            paymentTerm3: 'subscriptionManagement.billing.paymentTerm3',
            paymentTerm4: 'subscriptionManagement.billing.paymentTerm4',
            paymentTerm5: 'subscriptionManagement.billing.paymentTerm5'
        },
        overages: {
            overagePolicy: 'subscriptionManagement.overages.overagePolicy',
            autoBlock: 'subscriptionManagement.overages.autoBlock',
            autoBlockDesc: 'subscriptionManagement.overages.autoBlockDesc',
            primaryMetric: 'subscriptionManagement.overages.primaryMetric',
            primaryMetricDesc: 'subscriptionManagement.overages.primaryMetricDesc',
            notificationSettings: 'subscriptionManagement.overages.notificationSettings',
            thresholdAlerts: 'subscriptionManagement.overages.thresholdAlerts',
            thresholdAlertsDesc: 'subscriptionManagement.overages.thresholdAlertsDesc',
            alertThreshold: 'subscriptionManagement.overages.alertThreshold',
            notificationFrequency: 'subscriptionManagement.overages.notificationFrequency',
            daily: 'subscriptionManagement.overages.daily',
            weekly: 'subscriptionManagement.overages.weekly',
            monthly: 'subscriptionManagement.overages.monthly',
            warningTitle: 'subscriptionManagement.overages.warningTitle',
            warningDesc: 'subscriptionManagement.overages.warningDesc',
            reset: 'subscriptionManagement.overages.reset',
            saveChanges: 'subscriptionManagement.overages.saveChanges',
            savedSuccess: 'subscriptionManagement.overages.savedSuccess'
        },
        notificationSettings: {
            title: 'subscriptionManagement.notificationSettings.title',
            monitorMetrics: 'subscriptionManagement.notificationSettings.monitorMetrics',
            triggerWhen: 'subscriptionManagement.notificationSettings.triggerWhen',
            frequency: 'subscriptionManagement.notificationSettings.frequency',
            hourly: 'subscriptionManagement.notificationSettings.hourly',
            daily: 'subscriptionManagement.notificationSettings.daily',
            monthly: 'subscriptionManagement.notificationSettings.monthly',
            saveSettings: 'subscriptionManagement.notificationSettings.saveSettings'
        }
    }
};

export default Messages;

export function translateMessages(i18n) {
    translate(Messages, i18n);
}

function translate(messages, i18n) {
    for (let key in messages) {
        if (isFunction(messages[key])) {
            let translation = messages[key]();
            messages[key] = function() {
                let parameters = {};
                for (let index in arguments) {
                    parameters[translation.paramsMap[index]] = arguments[index];
                }
                return i18n.t(translation.key, parameters);
            };
        } else if (typeof messages[key] === 'object') {
            translate(messages[key], i18n);
        } else {
            messages[key] = i18n.t(messages[key]);
        }
    }
}
